import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "flatpickr/dist/themes/material_blue.css";
import FlatPickr from "react-flatpickr";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { format } from "date-fns";
import InputMask from "react-input-mask";
import * as Yup from "yup";
import { useFormik, Formik, Form, Field, ErrorMessage } from "formik";
import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  Tooltip,
  NavLink,
  Collapse,
} from "reactstrap";
import Switch from "react-switch";
import Select from "react-select";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import {
  FiUser,
  FiChevronUp,
  FiChevronDown,
  FiEdit3,
  FiCalendar,
} from "react-icons/fi";
import { BsFillInfoCircleFill } from "react-icons/bs";

import { useParams } from "react-router-dom";
import IdentificationCard from "components/Common/IdentificationCard";
import SouscriptionsCard from "components/Common/SouscriptionsCard";
import TableComponent from "components/Common/TableComponent";
//import { C } from "@fullcalendar/core/internal-common";
import Config from "config";
import { makeSelectStyles } from "../../common/selectStyles";
function InvestorDetail() {
  const api = Config.backOffice.apiName;
  const backUrl = Config.backOffice.url;
  let { id } = useParams();
  const navigate = useNavigate();
  const tableaustyles = {
    background: "#555B21",
    color: "white",
    paddingTop: "5px",
    paddingBottom: "5px",
  };
  const type_compte = localStorage.getItem("typeDeCompte_" + api);
  const colStyle = {
    width: "20em", // Largeur fixe pour la première colonne
    whiteSpace: "wrap", // Empêche le texte de revenir à la ligne
    display: "inline-block", // Permet de conserver le texte sur une seule ligne
    color: "#7f7f7f",
    verticalAlign: "middle", // Alignement vertical au centre pour le texte
    display: "flex", // Utilisation de flexbox pour aligner les éléments horizontalement
    alignItems: "center", // Centrage vertical du texte et de l'input
  };
  const [loading, setLoading] = useState(true);
  const [wait, setWait] = useState(1000);
  const token = localStorage.getItem("auth_token_" + api);
  const [investisseursData, setInvestisseursData] = useState([]);
  //meta title
  const [isAccordionOpen, setIsAccordionOpen] = useState(true);
  const toggleAccordion = () => {
    setIsAccordionOpen(!isAccordionOpen);
  };
  const [isDetailsAccordionOpen, setIsDetailsAccordionOpen] = useState(true);
  const toggleDetailsAccordion = () => {
    setIsDetailsAccordionOpen(!isDetailsAccordionOpen);
  };
  const [isIdentificationAccordionOpen, setIsIdentificationAccordionOpen] =
    useState(true);
  const toggleIdentificationAccordion = () => {
    setIsIdentificationAccordionOpen(!isIdentificationAccordionOpen);
  };
  const [isRenseignementsAccordionOpen, setIsRenseignementsAccordionOpen] =
    useState(true);
  const toggleRenseignementsAccordion = () => {
    setIsRenseignementsAccordionOpen(!isRenseignementsAccordionOpen);
  };
  const [
    isIdentificationMoralAccordionOpen,
    setIsIdentificationMoralAccordionOpen,
  ] = useState(true);
  const toggleIdentificationMoralAccordion = () =>
    setIsIdentificationMoralAccordionOpen((o) => !o);
  const [isCaracteristiquesAccordionOpen, setIsCaracteristiquesAccordionOpen] =
    useState(true);
  const toggleCaracteristiquesAccordion = () =>
    setIsCaracteristiquesAccordionOpen((o) => !o);
  const [isContactAccordionOpen, setIsContactAccordionOpen] = useState(true);
  const toggleContactAccordion = () => setIsContactAccordionOpen((o) => !o);
  const [isAdressesAccordionOpen, setIsAdressesAccordionOpen] = useState(true);
  const toggleAdressesAccordion = () => setIsAdressesAccordionOpen((o) => !o);
  const [isEmailsAccordionOpen, setIsEmailsAccordionOpen] = useState(true);
  const toggleEmailsAccordion = () => setIsEmailsAccordionOpen((o) => !o);
  const [isAdressesPostalesAccordionOpen, setIsAdressesPostalesAccordionOpen] =
    useState(true);
  const toggleAdressesPostalesAccordion = () =>
    setIsAdressesPostalesAccordionOpen((o) => !o);
  const [isNumerosAccordionOpen, setIsNumerosAccordionOpen] = useState(true);
  const toggleNumerosAccordion = () => setIsNumerosAccordionOpen((o) => !o);
  const [comments, setComments] = useState(""); // Commentaire
  const [nom, setNom] = useState(""); // Nom
  const [prenom, setPrenom] = useState(""); // Prenom
  const [dateNaissance, setDateNaissance] = useState(""); // date de naissance
  const [villeNaissance, setVilleNaissance] = useState(""); // ville de naissance
  const smartCapitalizeWithDash = (word, originalWord) => {
    return word
      .split("-")
      .map((subWord, subIndex) => {
        const originalSubWord = originalWord.split("-")[subIndex] || "";

        // Préserve les majuscules existantes
        return subWord
          .split("")
          .map((char, charIndex) => {
            const originalChar = originalSubWord[charIndex];
            if (originalChar && originalChar === originalChar.toUpperCase()) {
              return char.toUpperCase();
            }
            return charIndex === 0 ? char.toUpperCase() : char.toLowerCase();
          })
          .join("");
      })
      .join("-");
  };

  const handleParenthesis = (word, originalWord) => {
    // Gérer les parenthèses comme "Casablanca (Maroc)"
    if (word.includes("(") && word.includes(")")) {
      const mainPart = word.substring(0, word.indexOf("(")).trim();
      const parenthesisPart = word.substring(
        word.indexOf("(") + 1,
        word.indexOf(")")
      );
      const afterParenthesis = word.substring(word.indexOf(")") + 1);

      // Parties originales pour préserver majuscules
      const originalMainPart = originalWord
        .substring(0, originalWord.indexOf("("))
        .trim();
      const originalParenthesisPart = originalWord.substring(
        originalWord.indexOf("(") + 1,
        originalWord.indexOf(")")
      );

      const capitalizedMain = smartCapitalizeWithDash(
        mainPart,
        originalMainPart
      );
      const capitalizedParenthesis = smartCapitalizeWithDash(
        parenthesisPart,
        originalParenthesisPart
      );

      return `${capitalizedMain} (${capitalizedParenthesis})${afterParenthesis}`;
    }
    return smartCapitalizeWithDash(word, originalWord);
  };
  const handleVilleNaissanceChange = (e) => {
    const rawValue = e.target.value;

    // Utilise une regex pour capitaliser chaque mot
    const transformedValue = rawValue.toLowerCase().replace(/\b\w/g, (char) => {
      return char.toUpperCase();
    });

    console.log(transformedValue);
    setVilleNaissance(transformedValue);
  };

  const [depNaissance, setDepNaissance] = useState(""); // departement de naissance
  const [profession, setProfession] = useState(""); // profession
  const [adresse, setAdresse] = useState(""); // adresse
  // tableau adresse postales PP
  const [complement, setComplement] = useState(""); // complement
  const [codePostal, setCodePostal] = useState(""); // code postal
  const [ville, setVille] = useState(""); // ville
  const [telFixe, setTelFixe] = useState(""); // tel fixe
  // tableau adresse email
  const [email, setEmail] = useState("");
  // tableau numéros de téléphone
  const [numero, setNumero] = useState("");

  const [courrier, setCourrier] = useState(""); //Courrier
  const [titre, setTitre] = useState(""); // Titre
  // PM
  const [denomSocial, setDenomSocial] = useState(""); // Denomination social
  const [numeroRcs, setNumeroRcs] = useState(""); // Numéro RCS
  const [telephone, setTelephone] = useState(""); // Telephone
  const [fax, setFax] = useState(""); // Fax
  const [emailPm, setEmailPm] = useState(""); // email PM
  const [canEditInvestor, setCanEditInvestor] = useState(true);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggleTooltip = () => setTooltipOpen(!tooltipOpen);
  /*************************   Statut *******************************/
  const [statutData, setStatutData] = useState({ data: [] });
  const [selectedStatut, setSelectedStatut] = useState("");
  function formatDateToFrench(inputDate) {
    // Crée un objet Date à partir de la date d'entrée
    const date = new Date(inputDate);

    // Extrayez le jour, le mois et l'année de l'objet Date
    const day = date.getDate();
    const month = date.getMonth() + 1; // Les mois sont indexés à partir de zéro, donc ajoutez 1
    const year = date.getFullYear();

    // Formate la date en format français (DD/MM/YYYY)
    const formattedDate = `${day.toString().padStart(2, "0")}/${month
      .toString()
      .padStart(2, "0")}/${year}`;

    return formattedDate;
  }
  const capitalizeWordWithDash = (word) => {
    return word
      .split("-")
      .map(
        (subWord) =>
          subWord.charAt(0).toUpperCase() + subWord.slice(1).toLowerCase()
      )
      .join("-");
  };

  const getData = async () => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/investisseurs/${id}/edit`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(response.status);
      if (response.status === 403) {
        navigate(`${backUrl}/forbidden`);
      }
      if (response.status === 500) {
        navigate(`${backUrl}/error`);
      }
      if (response.status === 203) {
        navigate(`${backUrl}/error404`);
      }
      if (response.status === 401) {
        localStorage.removeItem("auth_token_" + api);
        localStorage.removeItem("authUser_" + api);
        localStorage.removeItem("sideBar_" + api);
        navigate(`${backUrl}/login`);
        window.location.reload(false);
      }
      // if (!response.ok) {
      //   localStorage.removeItem("auth_token_"+api);
      //   localStorage.removeItem("authUser_"+api);
      //   localStorage.removeItem("sideBar_"+api);
      //   history('/backoffice_test/login');
      //   window.location.reload(false);
      //   // throw new Error("Erreur lors de la récupération des données");
      //   // rediriger vers le login
      // }

      const investisseursData = await response.json();
      setInvestisseursData(investisseursData);
      if (investisseursData?.can_modify_investisseur == true) {
        setCanEditInvestor(true);
      } else {
        setCanEditInvestor(false);
        setActiveTab("contact");
      }
      setSelectedStatut(
        investisseursData?.detail_investisseur?.identification.Statut
      );
      setSelectedConseil(
        investisseursData?.detail_investisseur?.identification.Partenaire
      );
      setSelectedCourrier(
        investisseursData?.detail_investisseur?.identification.Courrier
      );
      setSelectedCsp(
        investisseursData?.detail_investisseur?.identification.Csp
      );
      if (investisseursData?.detail_investisseur?.identification.Type == "PP") {
        setNom(investisseursData?.detail_nom_investisseur?.identification.Nom);
        setPrenom(
          investisseursData?.detail_nom_investisseur?.identification.Prénom
        );
        setSelectedTitre(
          investisseursData?.detail_nom_investisseur?.identification.Titre
        );
        setSelectedSociete(
          investisseursData?.detail_nom_investisseur?.identification.Société
        );
        setDateNaissance(
          formatDateToFrench(
            investisseursData?.detail_nom_investisseur?.renseignements_divers?.[
              "Date de naissance"
            ]
          )
        );
        setVilleNaissance(
          investisseursData?.detail_nom_investisseur?.renseignements_divers?.[
            "Ville de naissance"
          ]
        );
        setDepNaissance(
          investisseursData?.detail_nom_investisseur?.renseignements_divers?.[
            "Code département de naissance"
          ]
        );
        setProfession(
          investisseursData?.detail_nom_investisseur?.renseignements_divers?.[
            "Profession"
          ]
        );
        setSelectedSituationMatrimoniale(
          investisseursData?.detail_nom_investisseur?.renseignements_divers?.[
            "Situation matrimoniale"
          ]
        );
        setFormAdressePostals(
          investisseursData?.detail_nom_investisseur?.adresses_postales
            ?.Adresses.data
        );
        setFormAdresseEmails(
          investisseursData?.detail_nom_investisseur?.adresses_email?.Emails
            .data
        );
        setFormNumeroTelephones(
          investisseursData?.detail_nom_investisseur?.numeros_de_telephone?.[
            "Téléphones"
          ].data
        );
      }
      if (investisseursData?.detail_investisseur?.identification.Type == "PM") {
        setFormAdressePostals(
          investisseursData?.detail_nom_investisseur?.adresses?.Adresses.data
        );
        setSelectedForme(
          investisseursData?.detail_nom_investisseur?.caracteristiques?.[
            "Forme juridique"
          ]
        );
        setSelectedPresidentPP(
          investisseursData?.detail_nom_investisseur?.caracteristiques?.[
            "Président (PP)"
          ]
        );
        setSelectedPresidentPM(
          investisseursData?.detail_nom_investisseur?.caracteristiques?.[
            "Président (PM)"
          ]
        );
        setSelectedDir(
          investisseursData?.detail_nom_investisseur?.caracteristiques?.[
            "Directeur Général"
          ]
        );
        setDenomSocial(
          investisseursData?.detail_nom_investisseur?.identification?.[
            "Dénomination sociale"
          ]
        );
        setNumeroRcs(
          investisseursData?.detail_nom_investisseur?.identification?.["N° RCS"]
        );
        setTelephone(
          investisseursData?.detail_nom_investisseur?.contact?.["Téléphone"]
        );
        setFax(investisseursData?.detail_nom_investisseur?.contact?.["Fax"]);
        setEmailPm(
          investisseursData?.detail_nom_investisseur?.contact?.["Email"]
        );
      }

      setComments(investisseursData?.detail_investisseur?.details.Commentaires);
      setTitre(
        investisseursData?.detail_nom_investisseur?.identification.Titre
      );
    } catch (error) {
      console.error(error);
    }
  };
  const renderStatutOptions = () => {
    return [
      {
        options: statutData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const handleStatutChange = (e) => {
    setSelectedStatut(e);
  };
  const getStatut = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/investisseurs/statut_investisseurs`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((statut) => {
          setStatutData(statut);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END Statut *******************************/

  /*************************   Conseil  *******************************/

  const [conseilData, setConseilData] = useState({ data: [] });
  const [selectedConseil, setSelectedConseil] = useState("");
  const renderConseilOptions = () => {
    return [
      {
        options: conseilData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const handleConseilChange = (e) => {
    setSelectedConseil(e);
  };
  const getConseil = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/partenaires`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((conseil) => {
          setConseilData(conseil);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END Conseil *******************************/
  /*************************   Courrier  *******************************/
  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        {" "}
        Non
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        {" "}
        Oui
      </div>
    );
  };
  const courrierData = {
    data: [
      { id: 1, label: "Oui" },
      { id: 2, label: "Non" },
    ],
  };
  const [selectedCourrier, setSelectedCourrier] = useState("");

  const [selectedYesNo, setSelectedYesNo] = useState("");
  const renderYesNoOptions = () => {
    return [
      <option key="" value=""></option>,
      ...courrierData.data.map((dataItem) => (
        <option key={dataItem.id} value={dataItem.id}>
          {dataItem.label}
        </option>
      )),
    ];
  };
  const handleYesNoChange = (e) => {
    setSelectedYesNo(e.target.value);
  };
  /*************************   END Courrier *******************************/
  /*************************   Titre  *******************************/
  const [titreData, setTitreData] = useState({ data: [] });
  const [selectedTitre, setSelectedTitre] = useState("");
  const renderTitreOptions = () => {
    return [
      {
        options: titreData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  const handleTitreChange = (e) => {
    setSelectedTitre(e);
  };
  const getTitre = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/titres`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((titre) => {
          setTitreData(titre);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END Titre *******************************/
  /*************************   Societe  *******************************/
  const [societeData, setSocieteData] = useState({ data: [] });
  const [selectedSociete, setSelectedSociete] = useState("");

  const renderSocieteOptions = () => {
    return [
      {
        options: societeData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const handleSocieteChange = (e) => {
    setSelectedSociete(e);
  };
  const getSociete = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/societes`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((societe) => {
          setSocieteData(societe);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END Societe *******************************/
  /*************************   Csp  *******************************/
  const [cspData, setCspData] = useState({ data: [] });
  const [selectedCsp, setSelectedCsp] = useState("");
  const renderCspOptions = () => {
    return [
      <option key="" value=""></option>,
      ...cspData.data.map((dataItem) => (
        <option key={dataItem.id} value={dataItem.id}>
          {dataItem.label}
        </option>
      )),
    ];
  };
  const handleCspChange = (e) => {
    setSelectedCsp(e.target.value);
  };
  const getCsp = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/csps`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((csp) => {
          setCspData(csp);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END Csp *******************************/
  /*************************   SituationMatrimoniale  *******************************/
  const [situationMatrimonialeData, setSituationMatrimonialeData] = useState({
    data: [],
  });

  const [selectedSituationMatrimoniale, setSelectedSituationMatrimoniale] =
    useState("");

  const renderSituationMatrimonialeOptions = () => {
    return [
      {
        options: situationMatrimonialeData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const handleSituationMatrimonialeChange = (e) => {
    setSelectedSituationMatrimoniale(e);
  };
  const getSituationMatrimoniale = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/investisseurs/situation_matrimoniales`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((situationMatrimoniale) => {
          setSituationMatrimonialeData(situationMatrimoniale);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END SituationMatrimoniale *******************************/
  /*************************   TypesAdress  *******************************/
  const [typesAdressData, setTypesAdressData] = useState({ data: [] });
  const [activeTab, setActiveTab] = useState(
    history?.state?.usr?.active || (canEditInvestor ? "details" : "contact")
  ); // État pour contrôler l'affichage
  const renderTypesAdressOptions = () => {
    return [
      <option key="" value=""></option>,
      ...typesAdressData.data.map((dataItem) => (
        <option key={dataItem.id} value={dataItem.id}>
          {dataItem.label}
        </option>
      )),
    ];
  };
  const getTypesAdress = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/types_adresss`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((typesAdress) => {
          setTypesAdressData(typesAdress);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END TypesAdress *******************************/
  /*************************   TypesTelephone  *******************************/
  const [typesTelephoneData, setTypesTelephoneData] = useState({ data: [] });
  const renderTypesTelephoneOptions = () => {
    return [
      <option key="" value=""></option>,
      ...typesTelephoneData.data.map((dataItem) => (
        <option key={dataItem.id} value={dataItem.id}>
          {dataItem.label}
        </option>
      )),
    ];
  };
  const getTypesTelephone = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/types_telephones`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((typesTelephone) => {
          setTypesTelephoneData(typesTelephone);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END TypesTelephone *******************************/

  /*************************   TypesEmail  *******************************/
  const [typesEmailData, setTypesEmailData] = useState({ data: [] });
  const renderTypesEmailOptions = () => {
    return [
      <option key="" value=""></option>,
      ...typesEmailData.data.map((dataItem) => (
        <option key={dataItem.id} value={dataItem.id}>
          {dataItem.label}
        </option>
      )),
    ];
  };

  const getTypesEmail = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/types_emails`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((typesEmail) => {
          setTypesEmailData(typesEmail);
        });
    } catch (error) {
      console.log(error);
    }
  };

  /*************************   END TypesEmail *******************************/

  /*************************   Pays  *******************************/
  const [payData, setPayData] = useState({ data: [] });
  const renderPayOptions = () => {
    const emptyOption = (
      <option key="empty" value="">
        Sélectionner une option
      </option>
    );

    return [
      emptyOption,
      ...payData.data.map((dataItem) => (
        <option key={dataItem.id} value={dataItem.id}>
          {dataItem.label}
        </option>
      )),
    ];
  };
  const getPay = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/pays`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((pay) => {
          setPayData(pay);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END Pays *******************************/
  /*************************   Formes juridiques         *******************************/
  const [formeJuridique, setFormeJuridique] = useState({ data: [] });
  const [selectedForme, setSelectedForme] = useState("");
  const renderFormeOptions = () => {
    return [
      {
        options: formeJuridique.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const handleFormeChange = (e) => {
    setSelectedForme(e);
  };
  const getFormeJuri = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/formes_juridiques`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((formeJuridique) => {
          setFormeJuridique(formeJuridique);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END Formes juridiques         *******************************/

  /*************************   Président PM          *******************************/
  const [presidentData, setPresidentData] = useState({ data: [] });
  const [selectedPresidentPM, setSelectedPresidentPM] = useState("");
  const [selectedPresidentPP, setSelectedPresidentPP] = useState("");

  const renderPresidentOptions = () => {
    return [
      {
        options: presidentData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const handlePresidentChange = (e) => {
    setSelectedPresidentPM(e);
  };
  const handlePresidentPPChange = (e) => {
    setSelectedPresidentPP(e);
  };
  const getPresident = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/societes2`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((president) => {
          setPresidentData(president);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END President         *******************************/

  /*************************   Directeur          *******************************/
  const [directeurData, setDirecteurData] = useState({ data: [] });
  const [selectedDir, setSelectedDir] = useState("");
  const renderDirecteurOptions = () => {
    return [
      {
        options: directeurData.data.map((dataItem) => ({
          label: dataItem.label,
          id: dataItem.id,
        })),
      },
    ];
  };
  const handleDirecteurChange = (e) => {
    setSelectedDir(e);
  };
  const getDirecteur = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/contacts`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((directeur) => {
          setDirecteurData(directeur);
          setWait(0);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END Directeur         *******************************/

  /******************************* HMF adresses postales *******************************************/
  const [formAdressePostals, setFormAdressePostals] = useState({});

  const onAddFormAdressePostal = () => {
    const modifiedAdressePostals = [...formAdressePostals];
    modifiedAdressePostals.push({
      index: modifiedAdressePostals.length + 1,
      id: null,
      // principale: null,
      // types_adress_id: null,
      adresse: null,
      complement: null,
      code_postal: null,
      ville: null,
      pay_id: null,
      tel_fixe: null,
    });
    setFormAdressePostals(modifiedAdressePostals);
  };

  const onDeleteFormAdressePostal = (id) => {
    var modifiedAdressePostals = [...formAdressePostals];
    modifiedAdressePostals = modifiedAdressePostals.filter(
      (x) => x["index"] !== id
    );
    setFormAdressePostals(modifiedAdressePostals);
  };
  /******************************* END HMF adresses postales *******************************************/

  /******************************* HMF adresses postales PM *******************************************/

  const onAddFormAdressePostalPM = () => {
    const modifiedAdressePostals = [...formAdressePostals];
    modifiedAdressePostals.push({
      index: modifiedAdressePostals.length + 1,
      id: null,
      siege: null,
      adresse: null,
      complement: null,
      code_postal: null,
      ville: null,
      pay_id: null,
      tel: null,
    });
    setFormAdressePostals(modifiedAdressePostals);
  };

  const onDeleteFormAdressePostalPM = (id) => {
    var modifiedAdressePostals = [...formAdressePostals];
    modifiedAdressePostals = modifiedAdressePostals.filter(
      (x) => x["index"] !== id
    );
    setFormAdressePostals(modifiedAdressePostals);
  };
  const handleInputChange = (index, field, value) => {
    const modifiedAdressePostals = formAdressePostals.map((adressePostal) => {
      if (adressePostal.index === index) {
        return {
          ...adressePostal,
          [field]: value,
        };
      }
      return adressePostal;
    });

    setFormAdressePostals(modifiedAdressePostals);
  };
  /******************************* END HMF adresses postales *******************************************/
  /******************************* HMF adresses emails *******************************************/
  const [formAdresseEmails, setFormAdresseEmails] = useState({});

  const onAddFormAdresseEmail = () => {
    const modifiedAdresseEmails = [...formAdresseEmails];
    modifiedAdresseEmails.push({
      index: modifiedAdresseEmails.length + 1,
      id: null,
      // types_email_id: null,
      email: null,
    });
    setFormAdresseEmails(modifiedAdresseEmails);
  };

  const onDeleteFormAdresseEmail = (id) => {
    var modifiedAdresseEmails = [...formAdresseEmails];
    modifiedAdresseEmails = modifiedAdresseEmails.filter(
      (x) => x["index"] !== id
    );
    setFormAdresseEmails(modifiedAdresseEmails);
  };
  const handleInputChangeEmail = (id, field, value) => {
    const modifiedAdresseEmails = formAdresseEmails.map((adresseEmail) => {
      if (adresseEmail.index === id) {
        return {
          ...adresseEmail,
          [field]: value,
        };
      }
      return adresseEmail;
    });

    setFormAdresseEmails(modifiedAdresseEmails);
  };
  /******************************* END HMF adresses emails *******************************************/
  /******************************* HMF adresses telephone *******************************************/
  const [formNumeroTelephones, setFormNumeroTelephones] = useState({});

  const onAddFormNumeroTelephone = () => {
    const modifiedNumeroTelephones = [...formNumeroTelephones];
    modifiedNumeroTelephones.push({
      index: modifiedNumeroTelephones.length + 1,
      id: null,
      // types_telephone_id: null,
      numero: null,
    });
    setFormNumeroTelephones(modifiedNumeroTelephones);
  };

  const onDeleteFormNumeroTelephone = (id) => {
    var modifiedNumeroTelephones = [...formNumeroTelephones];
    modifiedNumeroTelephones = modifiedNumeroTelephones.filter(
      (x) => x["index"] !== id
    );
    setFormNumeroTelephones(modifiedNumeroTelephones);
  };
  const handleInputChangeTelephone = (id, field, value) => {
    const modifiedNumeroTelephones = formNumeroTelephones.map((numeroTel) => {
      if (numeroTel.index === id) {
        return {
          ...numeroTel,
          [field]: value,
        };
      }
      return numeroTel;
    });

    setFormNumeroTelephones(modifiedNumeroTelephones);
  };
  /******************************* END HMF adresses telephone *******************************************/
  /******************************* Submit Edit *******************************************/

  const handleNavigate = () => {
    localStorage.setItem("key", true);
    localStorage.setItem("lastId", id);

    navigate(-1);
  };
  const handleSubmitPP = async (event) => {
    event.preventDefault();
    if (nom === "" && selectedStatut === null) {
      toast.error("Le statut et le nom ne peuvent pas être vide");
    } else if (nom === "") {
      toast.error("Le nom ne peut pas être vide");
    } else if (selectedStatut === null) {
      toast.error("Le statut ne peut pas être vide");
    } else {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/investisseurs/update`,
          {
            method: "PATCH",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              investisseur: {
                id: id,
                statut_investisseur_id: selectedStatut?.value || "",
                partenaire_id: selectedConseil?.value || "",
                courrier: selectedCourrier ? 1 : 2,
                commentaires: comments,
              },
              contact: {
                nom: nom,
                prenom: prenom,
                // societe_id: selectedSociete?.value || "",
                titre_id: selectedTitre?.value || "",
                date_de_naissance: dateNaissance,
                ville_de_naissance: villeNaissance,
                departement_ou_pays: depNaissance,
                profession: profession,
                situation_matrimoniale_id:
                  selectedSituationMatrimoniale?.value || "",
              },
              contact_hmf_adresses: formAdressePostals.map((obj) => {
                // on retire le champs index
                delete obj.index;
                return obj;
              }),
              contact_hmf_emails: formAdresseEmails.map((obj) => {
                delete obj.index;
                return obj;
              }),
              contact_hmf_telephones: formNumeroTelephones.map((obj) => {
                delete obj.index;
                return obj;
              }),
            }),
          }
        );

        if (response.ok) {
          console.log("PATCH request successful");
          handleNavigate();
        } else {
          console.error("PATCH request failed");
          const responseData = await response.json();

          if (
            (responseData && responseData.contact_validation) ||
            (responseData && responseData.investisseur_validation)
          ) {
            // Si le champ "contact_validation" est présent dans la réponse JSON
            const errors =
              responseData?.contact_validation ||
              responseData?.investisseur_validation;

            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        toast.error("Une erreur s'est produite");
      }
    }
  };
  const handleSubmitPM = async (event) => {
    event.preventDefault();
    if (denomSocial === "" && selectedStatut === null) {
      toast.error(
        "Le statut et la dénomination sociale ne peuvent pas être vide"
      );
    } else if (denomSocial === "") {
      toast.error("La dénomination sociale ne peut pas être vide");
    } else if (selectedStatut === null) {
      toast.error("Le statut ne peut pas être vide");
    } else {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/investisseurs/update`,
          {
            method: "PATCH",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              investisseur: {
                id: id,
                statut_investisseur_id: selectedStatut?.value || "",
                partenaire_id: selectedConseil?.value || "",
                courrier: selectedCourrier ? 1 : 2,
                commentaires: comments,
                rcs: numeroRcs,
              },
              societe: {
                raison_sociale: denomSocial,
                telephone: telephone,
                fax: fax,
                email: emailPm,
                formes_juridique_id: selectedForme?.value || "",
                societe_id: selectedPresidentPM?.value || "", // Président PM
                contact2_id: selectedDir?.value || selectedDir?.id || "", // directeur
                contact_id:
                  selectedPresidentPP?.value || selectedPresidentPP?.id || "", // Président PP
              },
              societe_hmf_adresses: formAdressePostals.map((obj) => {
                // on retire le champs index
                delete obj.index;
                return obj;
              }),
            }),
          }
        );

        if (response.ok) {
          console.log("PATCH request successful");

          handleNavigate({ key: true });
        } else {
          console.error("PATCH request failed");
          const responseData = await response.json();
          if (
            (responseData && responseData.societe_validation) ||
            (responseData && responseData.investisseur_validation)
          ) {
            // Si le champ "societe_validation" est présent dans la réponse JSON
            const errors =
              responseData.societe_validation[0] ||
              responseData?.investisseur_validation;

            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        toast.error("Une erreur s'est produite");
      }
    }
  };
  /******************************* END Submit Edit *******************************************/
  /******************************* Validation *******************************************/
  const validationSchema = Yup.object().shape({
    selectedStatut: Yup.string().required("Veuillez sélectionner un statut"),
  });
  /******************************* END Validation *******************************************/
  useEffect(() => {
    const fetchData = async () => {
      try {
        // commun
        await getData();
        await getStatut();
        await getConseil();
        await getPay();
        // if PP
        await getTitre();
        // await getSociete();
        await getCsp();
        await getSituationMatrimoniale();
        await getTypesAdress();
        // await getTypesTelephone();
        await getTypesEmail();
        // if PM
        await getFormeJuri();
        await getPresident();
        await getDirecteur();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);
  useEffect(() => {
    if (wait === 0) {
      setLoading(false);
      console.log("test finished");
    }
  }, [wait]);
  const handleTabClick = (tab) => {
    setActiveTab(tab); // Mettre à jour l'état lors du clic sur un onglet
  };
  document.title = "Investisseurs | Edit";
  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        {canEditInvestor && (
          <NavItem>
            <NavLink
              style={navStyle}
              className={`nav-link ${activeTab === "details" ? "active" : ""}`}
              to="#details"
              onClick={() => handleTabClick("details")}
            >
              Détails investisseur
            </NavLink>
          </NavItem>
        )}
        <NavItem>
          <NavLink
            style={navStyle}
            to="#contact"
            onClick={() => handleTabClick("contact")}
            className={`nav-link ${activeTab === "contact" ? "active" : ""}`}
          >
            {!loading ? (
              investisseursData?.detail_investisseur?.identification.Type ==
              "PP" ? (
                "Détails personne physique"
              ) : (
                "Détails personne morale"
              )
            ) : (
              <>
                <h5 className="card-title placeholder-glow">
                  <span
                    style={{ height: "1em" }}
                    className="placeholder col-6"
                  ></span>
                </h5>
              </>
            )}
          </NavLink>
        </NavItem>
      </Nav>
    );
  };

  const renderValue = (value) => {
    if (value == null) {
      return "";
    } else if (typeof value === "string" && value.trim() === "") {
      return "";
    } else if (value === "Validé") {
      return <span className="bg-success badge bg-secondary">{value}</span>;
    } else if (value === "En attente") {
      return <span className="bg-info badge bg-secondary">{value}</span>;
    } else {
      return value;
    }
  };
  const layout = localStorage.getItem("layoutMode");

  const styles = makeSelectStyles(layout);
  return (
    <React.Fragment>
      <div className="page-content" style={{ fontFamily: "sans-serif" }}>
        <div className="container-fluid">
          <Row>
            <Col lg="12">
              <Card>
                <CardBody className="border-bottom">
                  <div className="d-flex align-items-center">
                    <h5
                      className="mb-0 card-title flex-grow-1"
                      style={{ fontWeight: "bold", display: "flex" }}
                    >
                      <Link
                        to={`${backUrl}/investisseurs/`}
                        style={{
                          color: "#555B21",
                          textDecoration: "underline !important",
                        }}
                      >
                        Investisseurs
                      </Link>{" "}
                      <i className="bx bx-caret-right"></i>{" "}
                      {!loading ? (
                        investisseursData.sil
                      ) : (
                        <>
                          <span
                            className="placeholder col-3"
                            style={{ height: "1em" }}
                          ></span>
                        </>
                      )}
                    </h5>
                  </div>
                  {!loading &&
                  investisseursData?.detail_investisseur?.identification.Type ==
                    "PP" ? (
                    <div className="d-flex justify-content-end">
                      <div className="d-flex align-items-end">
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={handleSubmitPP} // validation PP
                        >
                          <i className="bx bx-send"></i> Valider
                        </button>
                        &nbsp; &nbsp;
                        <Link
                          to="#"
                          onClick={() => navigate(-1)}
                          className="btn btn-sm btn-soft-secondary "
                          style={{ width: "88.43px" }}
                        >
                          <i className="bx bx-arrow-back"></i> Annuler
                        </Link>
                      </div>
                    </div>
                  ) : (
                    <div className="d-flex justify-content-end">
                      <div className="d-flex align-items-end">
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={handleSubmitPM} // validation PM
                        >
                          <i className="bx bx-send"></i> Valider
                        </button>
                        &nbsp; &nbsp;
                        <Link
                          to="#"
                          onClick={() => navigate(-1)}
                          className="btn btn-sm btn-soft-secondary "
                          style={{ width: "88.43px" }}
                        >
                          <i className="bx bx-arrow-back"></i> Annuler
                        </Link>
                      </div>
                    </div>
                  )}
                </CardBody>
                {CustomNavTabs()}
                <CardBody>
                  {activeTab === "details" && canEditInvestor && (
                    <div>
                      {!loading ? (
                        <>
                          <Row>
                            <Col sm="6">
                              <Card
                                className="shadow-sm border-0 overflow-hidden"
                                style={{ borderRadius: "12px" }}
                              >
                                {/* En-tête cliquable */}
                                <div
                                  className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                  style={{
                                    background: "#555B21",
                                    letterSpacing: "0.5px",
                                    cursor: "pointer",
                                    userSelect: "none",
                                  }}
                                  onClick={toggleAccordion}
                                >
                                  <div className="d-flex align-items-center">
                                    <span style={{ fontSize: "0.82rem" }}>
                                      Identification
                                    </span>
                                  </div>
                                  {isAccordionOpen ? (
                                    <FiChevronUp size={16} />
                                  ) : (
                                    <FiChevronDown size={16} />
                                  )}
                                </div>

                                {/* Contenu repliable */}
                                <Collapse isOpen={isAccordionOpen}>
                                  <CardBody className="p-0">
                                    <div
                                      className="fields-container"
                                      style={{ paddingBottom: "8px" }}
                                    >
                                      {Object.entries(
                                        investisseursData?.detail_investisseur
                                          ?.identification || {}
                                      ).map(([key, value], index) => {
                                        const isRequired = key === "Statut";

                                        return (
                                          <div
                                            key={index}
                                            className="field-item px-2 py-1"
                                            style={{
                                              backgroundColor: "white",
                                              transition: "all 0.15s ease",
                                              borderLeft: isRequired
                                                ? "3px solid #dc3545"
                                                : "3px solid transparent",
                                              position: "relative",
                                            }}
                                            onMouseEnter={(e) => {
                                              if (isRequired) {
                                                e.currentTarget.style.backgroundColor =
                                                  "#ffe6e6";
                                                e.currentTarget.style.borderLeftColor =
                                                  "#dc3545";
                                              } else {
                                                e.currentTarget.style.backgroundColor =
                                                  "#e3f2fd";
                                                e.currentTarget.style.borderLeftColor =
                                                  "#007bff";
                                              }
                                            }}
                                            onMouseLeave={(e) => {
                                              e.currentTarget.style.backgroundColor =
                                                "white";
                                              if (isRequired) {
                                                e.currentTarget.style.borderLeftColor =
                                                  "#dc3545";
                                              } else {
                                                e.currentTarget.style.borderLeftColor =
                                                  "transparent";
                                              }
                                            }}
                                          >
                                            {/* Ligne de séparation subtile */}
                                            {index > 0 && (
                                              <div
                                                className="field-separator"
                                                style={{
                                                  position: "absolute",
                                                  top: "0",
                                                  left: "0",
                                                  right: "66%",
                                                  height: "1px",
                                                  background:
                                                    "linear-gradient(90deg, transparent 0%, #e9ecef 20%, #e9ecef 80%, transparent 100%)",
                                                }}
                                              />
                                            )}

                                            <Row className="align-items-center g-1">
                                              <Col
                                                xs={12}
                                                md={4}
                                                className="field-label"
                                              >
                                                <div className="d-flex align-items-center small text-muted">
                                                  <span
                                                    className="fw-medium"
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      letterSpacing: "0.2px",
                                                    }}
                                                  >
                                                    {key}
                                                  </span>
                                                  <span className="ms-1 text-primary">
                                                    :
                                                  </span>
                                                </div>
                                              </Col>

                                              <Col
                                                xs={12}
                                                md={8}
                                                className="field-input"
                                              >
                                                {key === "Statut" ? (
                                                  <div className="select-wrapper">
                                                    <Select
                                                      value={
                                                        selectedStatut?.label ==
                                                        null
                                                          ? null
                                                          : selectedStatut
                                                      }
                                                      onChange={
                                                        handleStatutChange
                                                      }
                                                      options={renderStatutOptions()}
                                                      isClearable={true}
                                                      classNamePrefix="select2-selection"
                                                      styles={styles(
                                                        selectedStatut == null
                                                      )}
                                                      menuPortalTarget={
                                                        document.body
                                                      }
                                                      placeholder="Sélectionner un statut..."
                                                    />
                                                    {selectedStatut ===
                                                      null && (
                                                      <div className="invalid-feedback d-block mt-1 small">
                                                        Statut ne peut pas être
                                                        vide
                                                      </div>
                                                    )}
                                                  </div>
                                                ) : key === "Courrier" ? (
                                                  <div
                                                    className="switch-wrapper d-flex align-items-center"
                                                    style={{
                                                      height: "32px",
                                                      minHeight: "32px",
                                                      padding: "0 0px",
                                                      backgroundColor: "#fff",
                                                      borderRadius: "6px",
                                                      transition:
                                                        "all 0.2s ease",
                                                    }}
                                                  >
                                                    <Switch
                                                      uncheckedIcon={
                                                        <Offsymbol />
                                                      }
                                                      checkedIcon={<OnSymbol />}
                                                      onColor={
                                                        localStorage.getItem(
                                                          "color_" + api
                                                        ) || "#555B21"
                                                      }
                                                      offColor="#6c757d"
                                                      onHandleColor="#fff"
                                                      offHandleColor="#fff"
                                                      handleDiameter={16}
                                                      borderRadius={10}
                                                      boxShadow="none"
                                                      activeBoxShadow="0 0 2px 4px rgba(0, 123, 255, 0.1)"
                                                      onChange={() => {
                                                        setSelectedCourrier(
                                                          !selectedCourrier
                                                        );
                                                      }}
                                                      checked={
                                                        selectedCourrier == 1
                                                          ? true
                                                          : false
                                                      }
                                                      className="uniform-switch"
                                                    />
                                                  </div>
                                                ) : key === "Partenaire" ? (
                                                  <div className="select-wrapper">
                                                    <Select
                                                      isDisabled={
                                                        type_compte !=
                                                          "builder" &&
                                                        type_compte != "admin"
                                                          ? true
                                                          : false
                                                      }
                                                      value={
                                                        selectedConseil?.label ==
                                                        null
                                                          ? null
                                                          : selectedConseil
                                                      }
                                                      onChange={
                                                        handleConseilChange
                                                      }
                                                      options={renderConseilOptions()}
                                                      isClearable={true}
                                                      classNamePrefix="select2-selection"
                                                      menuPortalTarget={
                                                        document.body
                                                      }
                                                      styles={styles(false)}
                                                      placeholder="Sélectionner un partenaire..."
                                                    />
                                                  </div>
                                                ) : key ===
                                                  "Comptes associés" ? (
                                                  <span>
                                                    <div
                                                      dangerouslySetInnerHTML={{
                                                        __html: value,
                                                      }}
                                                    />
                                                  </span>
                                                ) : (
                                                  <div className="input-wrapper position-relative">
                                                    <span
                                                      style={{
                                                        display: "block",
                                                        padding:
                                                          "0.25rem 0.5rem",
                                                        fontSize: "0.8rem",
                                                        color: "#495057",
                                                        backgroundColor:
                                                          "#f8f9fa",
                                                        borderRadius: "6px",
                                                        minHeight: "32px",
                                                        lineHeight: "1.5",
                                                      }}
                                                    >
                                                      {renderValue(value)}
                                                    </span>
                                                  </div>
                                                )}
                                              </Col>
                                            </Row>
                                          </div>
                                        );
                                      })}
                                    </div>
                                  </CardBody>
                                </Collapse>
                              </Card>
                            </Col>

                            <Col sm="6">
                              <IdentificationCard
                                title="Souscriptions"
                                details={
                                  investisseursData?.detail_investisseur
                                    ?.souscriptions
                                }
                              />

                              <Card
                                className="shadow-sm border-0 overflow-hidden"
                                style={{ borderRadius: "12px" }}
                              >
                                {/* En-tête cliquable */}
                                <div
                                  className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                  style={{
                                    background: "#555B21",
                                    letterSpacing: "0.5px",
                                    cursor: "pointer",
                                    userSelect: "none",
                                  }}
                                  onClick={toggleDetailsAccordion}
                                >
                                  <div className="d-flex align-items-center">
                                    <span style={{ fontSize: "0.82rem" }}>
                                      Détails
                                    </span>
                                  </div>
                                  {isDetailsAccordionOpen ? (
                                    <FiChevronUp size={16} />
                                  ) : (
                                    <FiChevronDown size={16} />
                                  )}
                                </div>

                                {/* Contenu repliable */}
                                <Collapse isOpen={isDetailsAccordionOpen}>
                                  <CardBody className="p-0">
                                    <div
                                      className="fields-container"
                                      style={{ paddingBottom: "8px" }}
                                    >
                                      <div
                                        className="field-item px-2 py-1"
                                        style={{
                                          backgroundColor: "white",
                                          transition: "all 0.15s ease",
                                          borderLeft: "3px solid transparent",
                                          position: "relative",
                                        }}
                                        onMouseEnter={(e) => {
                                          e.currentTarget.style.backgroundColor =
                                            "#e3f2fd";
                                          e.currentTarget.style.borderLeftColor =
                                            "#007bff";
                                        }}
                                        onMouseLeave={(e) => {
                                          e.currentTarget.style.backgroundColor =
                                            "white";
                                          e.currentTarget.style.borderLeftColor =
                                            "transparent";
                                        }}
                                      >
                                        <Row className="align-items-start g-1">
                                          <Col
                                            xs={12}
                                            md={4}
                                            className="field-label"
                                          >
                                            <div className="d-flex align-items-center small text-muted">
                                              <span
                                                className="fw-medium"
                                                style={{
                                                  fontSize: "0.8rem",
                                                  letterSpacing: "0.2px",
                                                  paddingTop: "6px",
                                                }}
                                              >
                                                Commentaires
                                              </span>
                                              <span className="ms-1 text-primary">
                                                :
                                              </span>
                                            </div>
                                          </Col>

                                          <Col
                                            xs={12}
                                            md={8}
                                            className="field-input"
                                          >
                                            <div className="textarea-wrapper position-relative">
                                              <textarea
                                                className="form-control form-control-sm shadow-sm border-0"
                                                value={
                                                  investisseursData
                                                    ?.detail_investisseur
                                                    ?.details?.Commentaires ||
                                                  ""
                                                }
                                                onChange={(e) =>
                                                  setComments(e.target.value)
                                                }
                                                rows={4}
                                                placeholder="Ajouter des commentaires..."
                                                style={{
                                                  width: "100%",
                                                  resize: "vertical",
                                                  fontSize: "0.8rem",
                                                  backgroundColor: "#f8f9fa",
                                                  borderRadius: "6px",
                                                  padding: "0.5rem",
                                                  transition: "all 0.2s ease",
                                                  minHeight: "80px",
                                                  lineHeight: "1.5",
                                                }}
                                                onFocus={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#ffffff";
                                                  e.currentTarget.style.boxShadow =
                                                    "0 0 0 0.2rem rgba(0, 123, 255, 0.15)";
                                                  e.currentTarget.style.outline =
                                                    "none";
                                                }}
                                                onBlur={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#f8f9fa";
                                                  e.currentTarget.style.boxShadow =
                                                    "none";
                                                }}
                                              />
                                              <FiEdit3
                                                size={12}
                                                className="position-absolute text-muted"
                                                style={{
                                                  right: "8px",
                                                  top: "8px",
                                                  pointerEvents: "none",
                                                  opacity: 0.5,
                                                }}
                                              />
                                            </div>
                                          </Col>
                                        </Row>
                                      </div>
                                    </div>
                                  </CardBody>
                                </Collapse>
                              </Card>
                            </Col>
                          </Row>
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} />
                      )}
                    </div>
                  )}
                  {activeTab === "contact" && (
                    <div>
                      {!loading &&
                      investisseursData?.detail_investisseur?.identification
                        .Type == "PP" ? (
                        <>
                          <Row>
                            <Col sm="6">
                              <Card
                                className="shadow-sm border-0 overflow-hidden"
                                style={{ borderRadius: "12px" }}
                              >
                                {/* En-tête cliquable */}
                                <div
                                  className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                  style={{
                                    background: "#555B21",
                                    letterSpacing: "0.5px",
                                    cursor: "pointer",
                                    userSelect: "none",
                                  }}
                                  onClick={toggleIdentificationAccordion}
                                >
                                  <div className="d-flex align-items-center">
                                    <span style={{ fontSize: "0.82rem" }}>
                                      Identification
                                    </span>
                                  </div>
                                  {isIdentificationAccordionOpen ? (
                                    <FiChevronUp size={16} />
                                  ) : (
                                    <FiChevronDown size={16} />
                                  )}
                                </div>

                                {/* Contenu repliable */}
                                <Collapse
                                  isOpen={isIdentificationAccordionOpen}
                                >
                                  <CardBody className="p-0">
                                    <div
                                      className="fields-container"
                                      style={{ paddingBottom: "8px" }}
                                    >
                                      {Object.entries(
                                        investisseursData
                                          ?.detail_nom_investisseur
                                          ?.identification || {}
                                      ).map(([key, value], index) => {
                                        const isRequired = key === "Nom";

                                        return (
                                          <div
                                            key={index}
                                            className="field-item px-2 py-1"
                                            style={{
                                              backgroundColor: "white",
                                              transition: "all 0.15s ease",
                                              borderLeft: isRequired
                                                ? "3px solid #dc3545"
                                                : "3px solid transparent",
                                              position: "relative",
                                            }}
                                            onMouseEnter={(e) => {
                                              if (isRequired) {
                                                e.currentTarget.style.backgroundColor =
                                                  "#ffe6e6";
                                                e.currentTarget.style.borderLeftColor =
                                                  "#dc3545";
                                              } else {
                                                e.currentTarget.style.backgroundColor =
                                                  "#e3f2fd";
                                                e.currentTarget.style.borderLeftColor =
                                                  "#007bff";
                                              }
                                            }}
                                            onMouseLeave={(e) => {
                                              e.currentTarget.style.backgroundColor =
                                                "white";
                                              if (isRequired) {
                                                e.currentTarget.style.borderLeftColor =
                                                  "#dc3545";
                                              } else {
                                                e.currentTarget.style.borderLeftColor =
                                                  "transparent";
                                              }
                                            }}
                                          >
                                            {/* Ligne de séparation subtile */}
                                            {index > 0 && (
                                              <div
                                                className="field-separator"
                                                style={{
                                                  position: "absolute",
                                                  top: "0",
                                                  left: "0",
                                                  right: "66%",
                                                  height: "1px",
                                                  background:
                                                    "linear-gradient(90deg, transparent 0%, #e9ecef 20%, #e9ecef 80%, transparent 100%)",
                                                }}
                                              />
                                            )}

                                            <Row className="align-items-center g-1">
                                              <Col
                                                xs={12}
                                                md={4}
                                                className="field-label"
                                              >
                                                <div className="d-flex align-items-center small text-muted">
                                                  <span
                                                    className="fw-medium"
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      letterSpacing: "0.2px",
                                                    }}
                                                  >
                                                    {key}
                                                  </span>
                                                  <span className="ms-1 text-primary">
                                                    :
                                                  </span>
                                                </div>
                                              </Col>

                                              <Col
                                                xs={12}
                                                md={8}
                                                className="field-input"
                                              >
                                                {key === "Titre" ? (
                                                  <div className="select-wrapper">
                                                    <Select
                                                      value={
                                                        selectedTitre?.label ==
                                                        null
                                                          ? null
                                                          : selectedTitre
                                                      }
                                                      onChange={
                                                        handleTitreChange
                                                      }
                                                      options={renderTitreOptions()}
                                                      isClearable={true}
                                                      classNamePrefix="select2-selection"
                                                      isSearchable={false}
                                                      placeholder="Sélectionner un titre..."
                                                      styles={styles(false)}
                                                      menuPortalTarget={
                                                        document.body
                                                      }
                                                    />
                                                  </div>
                                                ) : key === "Nom" ? (
                                                  <div className="input-wrapper position-relative">
                                                    <input
                                                      className={`form-control form-control-sm shadow-sm border-0 ${
                                                        nom === ""
                                                          ? "is-invalid"
                                                          : ""
                                                      }`}
                                                      style={{
                                                        textTransform:
                                                          "uppercase",
                                                        fontSize: "0.8rem",
                                                        backgroundColor:
                                                          "#f8f9fa",
                                                        borderRadius: "6px",
                                                        padding:
                                                          "0.375rem 2rem 0.375rem 0.5rem",
                                                        height: "32px",
                                                        transition:
                                                          "all 0.2s ease",
                                                      }}
                                                      value={nom}
                                                      required
                                                      onChange={(e) =>
                                                        setNom(
                                                          e.target.value.toUpperCase()
                                                        )
                                                      }
                                                      onFocus={(e) => {
                                                        e.currentTarget.style.backgroundColor =
                                                          "#ffffff";
                                                        e.currentTarget.style.boxShadow =
                                                          "0 0 0 0.2rem rgba(220, 53, 69, 0.15)";
                                                      }}
                                                      onBlur={(e) => {
                                                        e.currentTarget.style.backgroundColor =
                                                          "#f8f9fa";
                                                        e.currentTarget.style.boxShadow =
                                                          "none";
                                                      }}
                                                    />
                                                    <FiEdit3
                                                      size={12}
                                                      className="position-absolute text-muted"
                                                      style={{
                                                        right: "8px",
                                                        top: "50%",
                                                        transform:
                                                          "translateY(-50%)",
                                                        pointerEvents: "none",
                                                        opacity: 0.9,
                                                      }}
                                                    />
                                                    {nom === "" && (
                                                      <div className="invalid-feedback d-block mt-1 small">
                                                        Nom ne peut pas être
                                                        vide
                                                      </div>
                                                    )}
                                                  </div>
                                                ) : key === "Prénom" ? (
                                                  <div className="input-wrapper position-relative">
                                                    <input
                                                      className="form-control form-control-sm shadow-sm border-0"
                                                      style={{
                                                        textTransform:
                                                          "capitalize",
                                                        fontSize: "0.8rem",
                                                        backgroundColor:
                                                          "#f8f9fa",
                                                        borderRadius: "6px",
                                                        padding:
                                                          "0.375rem 2rem 0.375rem 0.5rem",
                                                        height: "32px",
                                                        transition:
                                                          "all 0.2s ease",
                                                      }}
                                                      value={prenom}
                                                      onChange={(e) =>
                                                        setPrenom(
                                                          e.target.value
                                                            .charAt(0)
                                                            .toUpperCase() +
                                                            e.target.value
                                                              .slice(1)
                                                              .toLowerCase()
                                                        )
                                                      }
                                                      onFocus={(e) => {
                                                        e.currentTarget.style.backgroundColor =
                                                          "#ffffff";
                                                        e.currentTarget.style.boxShadow =
                                                          "0 0 0 0.2rem rgba(0, 123, 255, 0.15)";
                                                      }}
                                                      onBlur={(e) => {
                                                        e.currentTarget.style.backgroundColor =
                                                          "#f8f9fa";
                                                        e.currentTarget.style.boxShadow =
                                                          "none";
                                                      }}
                                                    />
                                                    <FiEdit3
                                                      size={12}
                                                      className="position-absolute text-muted"
                                                      style={{
                                                        right: "8px",
                                                        top: "50%",
                                                        transform:
                                                          "translateY(-50%)",
                                                        pointerEvents: "none",
                                                        opacity: 0.9,
                                                      }}
                                                    />
                                                  </div>
                                                ) : (
                                                  <div className="input-wrapper position-relative">
                                                    <span
                                                      style={{
                                                        display: "block",
                                                        padding:
                                                          "0.25rem 0.5rem",
                                                        fontSize: "0.8rem",
                                                        color: "#495057",
                                                        backgroundColor:
                                                          "#f8f9fa",
                                                        borderRadius: "6px",
                                                        minHeight: "32px",
                                                        lineHeight: "1.5",
                                                      }}
                                                    >
                                                      {renderValue(value)}
                                                    </span>
                                                  </div>
                                                )}
                                              </Col>
                                            </Row>
                                          </div>
                                        );
                                      })}
                                    </div>
                                  </CardBody>
                                </Collapse>
                              </Card>
                            </Col>

                            <Col sm="6">
                              <Card
                                className="shadow-sm border-0 overflow-hidden"
                                style={{ borderRadius: "12px" }}
                              >
                                {/* En-tête cliquable */}
                                <div
                                  className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                  style={{
                                    background: "#555B21",
                                    letterSpacing: "0.5px",
                                    cursor: "pointer",
                                    userSelect: "none",
                                  }}
                                  onClick={toggleRenseignementsAccordion}
                                >
                                  <div className="d-flex align-items-center">
                                    <span style={{ fontSize: "0.82rem" }}>
                                      Renseignements Divers
                                    </span>
                                  </div>
                                  {isRenseignementsAccordionOpen ? (
                                    <FiChevronUp size={16} />
                                  ) : (
                                    <FiChevronDown size={16} />
                                  )}
                                </div>

                                {/* Contenu repliable */}
                                <Collapse
                                  isOpen={isRenseignementsAccordionOpen}
                                >
                                  <CardBody className="p-0">
                                    <div
                                      className="fields-container"
                                      style={{ paddingBottom: "8px" }}
                                    >
                                      {Object.entries(
                                        investisseursData
                                          ?.detail_nom_investisseur
                                          ?.renseignements_divers || {}
                                      ).map(([key, value], index) => {
                                        const isRequired = false;
                                        const safeKey = key.replace(
                                          /[^a-zA-Z0-9]/g,
                                          ""
                                        );

                                        return (
                                          <div
                                            key={index}
                                            className="field-item px-2 py-1"
                                            style={{
                                              backgroundColor: "white",
                                              transition: "all 0.15s ease",
                                              borderLeft: isRequired
                                                ? "3px solid #dc3545"
                                                : "3px solid transparent",
                                              position: "relative",
                                            }}
                                            onMouseEnter={(e) => {
                                              if (isRequired) {
                                                e.currentTarget.style.backgroundColor =
                                                  "#ffe6e6";
                                                e.currentTarget.style.borderLeftColor =
                                                  "#dc3545";
                                              } else {
                                                e.currentTarget.style.backgroundColor =
                                                  "#e3f2fd";
                                                e.currentTarget.style.borderLeftColor =
                                                  "#007bff";
                                              }
                                            }}
                                            onMouseLeave={(e) => {
                                              e.currentTarget.style.backgroundColor =
                                                "white";
                                              if (isRequired) {
                                                e.currentTarget.style.borderLeftColor =
                                                  "#dc3545";
                                              } else {
                                                e.currentTarget.style.borderLeftColor =
                                                  "transparent";
                                              }
                                            }}
                                          >
                                            {/* Ligne de séparation subtile */}
                                            {index > 0 && (
                                              <div
                                                className="field-separator"
                                                style={{
                                                  position: "absolute",
                                                  top: "0",
                                                  left: "0",
                                                  right: "66%",
                                                  height: "1px",
                                                  background:
                                                    "linear-gradient(90deg, transparent 0%, #e9ecef 20%, #e9ecef 80%, transparent 100%)",
                                                }}
                                              />
                                            )}

                                            <Row className="align-items-center g-1">
                                              <Col
                                                xs={12}
                                                md={4}
                                                className="field-label"
                                              >
                                                <div className="d-flex align-items-center small text-muted">
                                                  <span
                                                    className="fw-medium"
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      letterSpacing: "0.2px",
                                                    }}
                                                  >
                                                    {key}
                                                  </span>
                                                  {key ===
                                                    "Code département de naissance" && (
                                                    <>
                                                      <BsFillInfoCircleFill
                                                        size={14}
                                                        className="text-info ms-1"
                                                        style={{
                                                          cursor: "pointer",
                                                        }}
                                                        id={`Tooltip-${safeKey}`}
                                                      />
                                                      <Tooltip
                                                        placement="right"
                                                        isOpen={tooltipOpen}
                                                        target={`Tooltip-${safeKey}`}
                                                        toggle={toggleTooltip}
                                                      >
                                                        Saisir le numéro du
                                                        département pour la
                                                        France et le pays en
                                                        toutes lettres lorsque
                                                        l'investisseur est né
                                                        hors de France.
                                                      </Tooltip>
                                                    </>
                                                  )}
                                                  <span className="ms-1 text-primary">
                                                    :
                                                  </span>
                                                </div>
                                              </Col>

                                              <Col
                                                xs={12}
                                                md={8}
                                                className="field-input"
                                              >
                                                {key === "Date de naissance" ? (
                                                  <div className="input-wrapper position-relative">
                                                    <InputMask
                                                      mask="99/99/9999"
                                                      value={dateNaissance}
                                                      className="form-control form-control-sm shadow-sm border-0"
                                                      onChange={(
                                                        dateString
                                                      ) => {
                                                        setDateNaissance(
                                                          dateString.target
                                                            .value
                                                        );
                                                      }}
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        backgroundColor:
                                                          "#f8f9fa",
                                                        borderRadius: "6px",
                                                        padding:
                                                          "0.375rem 2rem 0.375rem 0.5rem",
                                                        height: "32px",
                                                        transition:
                                                          "all 0.2s ease",
                                                      }}
                                                      onFocus={(e) => {
                                                        e.currentTarget.style.backgroundColor =
                                                          "#ffffff";
                                                        e.currentTarget.style.boxShadow =
                                                          "0 0 0 0.2rem rgba(0, 123, 255, 0.15)";
                                                      }}
                                                      onBlur={(e) => {
                                                        e.currentTarget.style.backgroundColor =
                                                          "#f8f9fa";
                                                        e.currentTarget.style.boxShadow =
                                                          "none";
                                                      }}
                                                    />
                                                    <FiCalendar
                                                      size={12}
                                                      className="position-absolute text-muted"
                                                      style={{
                                                        right: "8px",
                                                        top: "50%",
                                                        transform:
                                                          "translateY(-50%)",
                                                        pointerEvents: "none",
                                                        opacity: 0.9,
                                                      }}
                                                    />
                                                  </div>
                                                ) : key ===
                                                  "Ville de naissance" ? (
                                                  <div className="input-wrapper position-relative">
                                                    <input
                                                      className="form-control form-control-sm shadow-sm border-0"
                                                      value={villeNaissance}
                                                      onChange={
                                                        handleVilleNaissanceChange
                                                      }
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        backgroundColor:
                                                          "#f8f9fa",
                                                        borderRadius: "6px",
                                                        padding:
                                                          "0.375rem 2rem 0.375rem 0.5rem",
                                                        height: "32px",
                                                        transition:
                                                          "all 0.2s ease",
                                                      }}
                                                      onFocus={(e) => {
                                                        e.currentTarget.style.backgroundColor =
                                                          "#ffffff";
                                                        e.currentTarget.style.boxShadow =
                                                          "0 0 0 0.2rem rgba(0, 123, 255, 0.15)";
                                                      }}
                                                      onBlur={(e) => {
                                                        e.currentTarget.style.backgroundColor =
                                                          "#f8f9fa";
                                                        e.currentTarget.style.boxShadow =
                                                          "none";
                                                      }}
                                                    />
                                                    <FiEdit3
                                                      size={12}
                                                      className="position-absolute text-muted"
                                                      style={{
                                                        right: "8px",
                                                        top: "50%",
                                                        transform:
                                                          "translateY(-50%)",
                                                        pointerEvents: "none",
                                                        opacity: 0.9,
                                                      }}
                                                    />
                                                  </div>
                                                ) : key ===
                                                  "Code département de naissance" ? (
                                                  <div className="input-wrapper position-relative">
                                                    <input
                                                      className="form-control form-control-sm shadow-sm border-0"
                                                      value={depNaissance}
                                                      onChange={(e) =>
                                                        setDepNaissance(
                                                          e.target.value
                                                        )
                                                      }
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        backgroundColor:
                                                          "#f8f9fa",
                                                        borderRadius: "6px",
                                                        padding:
                                                          "0.375rem 2rem 0.375rem 0.5rem",
                                                        height: "32px",
                                                        transition:
                                                          "all 0.2s ease",
                                                      }}
                                                      onFocus={(e) => {
                                                        e.currentTarget.style.backgroundColor =
                                                          "#ffffff";
                                                        e.currentTarget.style.boxShadow =
                                                          "0 0 0 0.2rem rgba(0, 123, 255, 0.15)";
                                                      }}
                                                      onBlur={(e) => {
                                                        e.currentTarget.style.backgroundColor =
                                                          "#f8f9fa";
                                                        e.currentTarget.style.boxShadow =
                                                          "none";
                                                      }}
                                                    />
                                                    <FiEdit3
                                                      size={12}
                                                      className="position-absolute text-muted"
                                                      style={{
                                                        right: "8px",
                                                        top: "50%",
                                                        transform:
                                                          "translateY(-50%)",
                                                        pointerEvents: "none",
                                                        opacity: 0.9,
                                                      }}
                                                    />
                                                  </div>
                                                ) : key === "Profession" ? (
                                                  <div className="input-wrapper position-relative">
                                                    <input
                                                      className="form-control form-control-sm shadow-sm border-0"
                                                      value={profession}
                                                      onChange={(e) =>
                                                        setProfession(
                                                          e.target.value
                                                        )
                                                      }
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        backgroundColor:
                                                          "#f8f9fa",
                                                        borderRadius: "6px",
                                                        padding:
                                                          "0.375rem 2rem 0.375rem 0.5rem",
                                                        height: "32px",
                                                        transition:
                                                          "all 0.2s ease",
                                                      }}
                                                      onFocus={(e) => {
                                                        e.currentTarget.style.backgroundColor =
                                                          "#ffffff";
                                                        e.currentTarget.style.boxShadow =
                                                          "0 0 0 0.2rem rgba(0, 123, 255, 0.15)";
                                                      }}
                                                      onBlur={(e) => {
                                                        e.currentTarget.style.backgroundColor =
                                                          "#f8f9fa";
                                                        e.currentTarget.style.boxShadow =
                                                          "none";
                                                      }}
                                                    />
                                                    <FiEdit3
                                                      size={12}
                                                      className="position-absolute text-muted"
                                                      style={{
                                                        right: "8px",
                                                        top: "50%",
                                                        transform:
                                                          "translateY(-50%)",
                                                        pointerEvents: "none",
                                                        opacity: 0.9,
                                                      }}
                                                    />
                                                  </div>
                                                ) : key === "CSP" ? (
                                                  <div className="select-wrapper">
                                                    <select
                                                      value={selectedCsp}
                                                      onChange={handleCspChange}
                                                      className="form-select form-select-sm shadow-sm border-0"
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        backgroundColor:
                                                          "#f8f9fa",
                                                        borderRadius: "6px",
                                                        padding:
                                                          "0.375rem 0.5rem",
                                                        height: "32px",
                                                        transition:
                                                          "all 0.2s ease",
                                                      }}
                                                      onFocus={(e) => {
                                                        e.currentTarget.style.backgroundColor =
                                                          "#ffffff";
                                                        e.currentTarget.style.boxShadow =
                                                          "0 0 0 0.2rem rgba(0, 123, 255, 0.15)";
                                                      }}
                                                      onBlur={(e) => {
                                                        e.currentTarget.style.backgroundColor =
                                                          "#f8f9fa";
                                                        e.currentTarget.style.boxShadow =
                                                          "none";
                                                      }}
                                                    >
                                                      {renderCspOptions()}
                                                    </select>
                                                  </div>
                                                ) : key ===
                                                  "Situation matrimoniale" ? (
                                                  <div className="select-wrapper">
                                                    <Select
                                                      value={
                                                        selectedSituationMatrimoniale?.label ==
                                                        null
                                                          ? null
                                                          : selectedSituationMatrimoniale
                                                      }
                                                      onChange={
                                                        handleSituationMatrimonialeChange
                                                      }
                                                      options={renderSituationMatrimonialeOptions()}
                                                      isClearable={true}
                                                      classNamePrefix="select2-selection"
                                                      isSearchable={false}
                                                      placeholder="Sélectionner..."
                                                      styles={styles(false)}
                                                      menuPortalTarget={
                                                        document.body
                                                      }
                                                    />
                                                  </div>
                                                ) : (
                                                  <div className="input-wrapper position-relative">
                                                    <span
                                                      style={{
                                                        display: "block",
                                                        padding:
                                                          "0.25rem 0.5rem",
                                                        fontSize: "0.8rem",
                                                        color: "#495057",
                                                        backgroundColor:
                                                          "#f8f9fa",
                                                        borderRadius: "6px",
                                                        minHeight: "32px",
                                                        lineHeight: "1.5",
                                                      }}
                                                    >
                                                      {renderValue(value)}
                                                    </span>
                                                  </div>
                                                )}
                                              </Col>
                                            </Row>
                                          </div>
                                        );
                                      })}
                                    </div>
                                  </CardBody>
                                </Collapse>
                              </Card>
                            </Col>
                          </Row>

                          <Card
                            className="shadow-sm border-0 overflow-hidden mb-4"
                            style={{ borderRadius: "12px" }}
                          >
                            {/* En‑tête cliquable */}
                            <div
                              className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                              style={{
                                background: "#555B21",
                                letterSpacing: "0.5px",
                                cursor: "pointer",
                                userSelect: "none",
                              }}
                              onClick={toggleAdressesPostalesAccordion}
                            >
                              <div className="d-flex align-items-center">
                                <span style={{ fontSize: "0.82rem" }}>
                                  Adresses
                                </span>
                              </div>
                              {isAdressesPostalesAccordionOpen ? (
                                <FiChevronUp size={16} />
                              ) : (
                                <FiChevronDown size={16} />
                              )}
                            </div>

                            <Collapse isOpen={isAdressesPostalesAccordionOpen}>
                              <CardBody className="p-2">
                                <Col sm="12">
                                  <div className="table-responsive">
                                    <table
                                      className="table table-bordered rounded-3 overflow-hidden"
                                      style={{
                                        borderCollapse: "collapse",
                                        width: "100%",
                                      }}
                                    >
                                      <thead>
                                        <tr>
                                          {investisseursData?.detail_nom_investisseur?.adresses_postales?.Adresses.header.map(
                                            (columnName, index) => (
                                              <th
                                                className="text-nowrap"
                                                style={tableaustyles}
                                                key={index}
                                              >
                                                {columnName}
                                              </th>
                                            )
                                          )}
                                          <th
                                            className="text-nowrap"
                                            style={{
                                              background: "#555B21",
                                              color: "white",
                                              paddingTop: "5px",
                                              paddingBottom: "5px",
                                              width: "1%",
                                            }}
                                            key="Del"
                                          ></th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {formAdressePostals.map((rowData) => (
                                          <tr key={rowData.index}>
                                            {Object.entries(rowData).map(
                                              ([key, value]) =>
                                                key !== "id" &&
                                                key !== "index" ? (
                                                  <td key={key}>
                                                    {key === "principale" ? (
                                                      <select
                                                        value={value}
                                                        name="principale"
                                                        className="form-control form-control-sm"
                                                        onChange={(e) =>
                                                          handleInputChange(
                                                            rowData.index,
                                                            e.target.name,
                                                            e.target.value
                                                          )
                                                        }
                                                      >
                                                        {renderYesNoOptions()}
                                                      </select>
                                                    ) : key ===
                                                      "types_adress_id" ? (
                                                      <select
                                                        value={value}
                                                        name="types_adress_id"
                                                        className="form-control form-control-sm"
                                                        onChange={(e) =>
                                                          handleInputChange(
                                                            rowData.index,
                                                            e.target.name,
                                                            e.target.value
                                                          )
                                                        }
                                                      >
                                                        {renderTypesAdressOptions()}
                                                      </select>
                                                    ) : key === "adresse" ||
                                                      key === "complement" ||
                                                      key === "code_postal" ||
                                                      key === "ville" ||
                                                      key === "tel_fixe" ? (
                                                      <input
                                                        className="form-control form-control-sm"
                                                        value={value}
                                                        name={key}
                                                        onChange={(e) =>
                                                          handleInputChange(
                                                            rowData.index,
                                                            e.target.name,
                                                            e.target.name ===
                                                              "ville"
                                                              ? e.target.value.toUpperCase()
                                                              : e.target.value
                                                          )
                                                        }
                                                      />
                                                    ) : key === "pay_id" ? (
                                                      <select
                                                        value={value}
                                                        name="pay_id"
                                                        className="form-control form-control-sm"
                                                        onChange={(e) =>
                                                          handleInputChange(
                                                            rowData.index,
                                                            e.target.name,
                                                            e.target.value
                                                          )
                                                        }
                                                      >
                                                        {renderPayOptions()}
                                                      </select>
                                                    ) : (
                                                      <span>{value}</span>
                                                    )}
                                                  </td>
                                                ) : (
                                                  <td
                                                    className="d-none"
                                                    key={key}
                                                  >
                                                    <input
                                                      type="hidden"
                                                      value={value}
                                                      readOnly
                                                    />
                                                  </td>
                                                )
                                            )}
                                            <td
                                              style={{
                                                width: "1%",
                                                textAlign: "center",
                                              }}
                                            >
                                              <i
                                                className="bx bx-trash"
                                                style={{
                                                  fontSize: "20px",
                                                  paddingTop: "5px",
                                                  textAlign: "center",
                                                  verticalAlign: "middle",
                                                  cursor: "pointer",
                                                }}
                                                onClick={() =>
                                                  onDeleteFormAdressePostal(
                                                    rowData.index
                                                  )
                                                }
                                              ></i>
                                            </td>
                                          </tr>
                                        ))}
                                        <tr>
                                          <td colSpan="9">
                                            <button
                                              type="button"
                                              style={tableaustyles}
                                              className="btn btn-info mt-3 mt-lg-0"
                                              onClick={onAddFormAdressePostal}
                                            >
                                              Ajouter
                                            </button>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </Col>
                              </CardBody>
                            </Collapse>
                          </Card>

                          <Row>
                            <Col sm="6">
                              <Card
                                className="shadow-sm border-0 overflow-hidden mb-4"
                                style={{ borderRadius: "12px" }}
                              >
                                {/* En‑tête cliquable */}
                                <div
                                  className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                  style={{
                                    background: "#555B21",
                                    letterSpacing: "0.5px",
                                    cursor: "pointer",
                                    userSelect: "none",
                                  }}
                                  onClick={toggleEmailsAccordion}
                                >
                                  <div className="d-flex align-items-center">
                                    <span style={{ fontSize: "0.82rem" }}>
                                      Emails
                                    </span>
                                  </div>
                                  {isEmailsAccordionOpen ? (
                                    <FiChevronUp size={16} />
                                  ) : (
                                    <FiChevronDown size={16} />
                                  )}
                                </div>

                                <Collapse isOpen={isEmailsAccordionOpen}>
                                  <CardBody className="p-2">
                                    <div className="table-responsive">
                                      <table className="table table-bordered rounded-3 overflow-hidden">
                                        <tbody>
                                          {formAdresseEmails.map((rowData) => (
                                            <tr key={rowData.index}>
                                              {Object.entries(rowData).map(
                                                ([key, value]) =>
                                                  key !== "id" &&
                                                  key !== "index" ? (
                                                    <td key={key}>
                                                      {key ===
                                                      "types_email_id" ? (
                                                        <select
                                                          value={value}
                                                          name="types_email_id"
                                                          className="form-control form-control-sm"
                                                          onChange={(e) =>
                                                            handleInputChangeEmail(
                                                              rowData.index,
                                                              e.target.name,
                                                              e.target.value
                                                            )
                                                          }
                                                        >
                                                          {renderTypesEmailOptions()}
                                                        </select>
                                                      ) : key === "email" ? (
                                                        <input
                                                          className="form-control form-control-sm"
                                                          value={value}
                                                          name="email"
                                                          onChange={(e) =>
                                                            handleInputChangeEmail(
                                                              rowData.index,
                                                              e.target.name,
                                                              e.target.value
                                                            )
                                                          }
                                                        />
                                                      ) : (
                                                        <span>{value}</span>
                                                      )}
                                                    </td>
                                                  ) : (
                                                    <td
                                                      className="d-none"
                                                      key={key}
                                                    >
                                                      <input
                                                        type="hidden"
                                                        size="10"
                                                        value={value}
                                                        readOnly
                                                      />
                                                    </td>
                                                  )
                                              )}
                                              <td
                                                style={{
                                                  width: "1%",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <i
                                                  className="bx bx-trash"
                                                  style={{
                                                    fontSize: "20px",
                                                    paddingTop: "5px",
                                                    textAlign: "center",
                                                    verticalAlign: "middle",
                                                    cursor: "pointer",
                                                  }}
                                                  onClick={() =>
                                                    onDeleteFormAdresseEmail(
                                                      rowData.index
                                                    )
                                                  }
                                                ></i>
                                              </td>
                                            </tr>
                                          ))}
                                          <tr>
                                            <td colSpan="9">
                                              <button
                                                type="button"
                                                style={tableaustyles}
                                                className="btn btn-info mt-3 mt-lg-0"
                                                onClick={onAddFormAdresseEmail}
                                              >
                                                Ajouter
                                              </button>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </CardBody>
                                </Collapse>
                              </Card>
                            </Col>
                            <Col sm="6">
                              <Card
                                className="shadow-sm border-0 overflow-hidden mb-4"
                                style={{ borderRadius: "12px" }}
                              >
                                {/* En‑tête cliquable */}
                                <div
                                  className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                  style={{
                                    background: "#555B21",
                                    letterSpacing: "0.5px",
                                    cursor: "pointer",
                                    userSelect: "none",
                                  }}
                                  onClick={toggleNumerosAccordion}
                                >
                                  <div className="d-flex align-items-center">
                                    <span style={{ fontSize: "0.82rem" }}>
                                      Numéros
                                    </span>
                                  </div>
                                  {isNumerosAccordionOpen ? (
                                    <FiChevronUp size={16} />
                                  ) : (
                                    <FiChevronDown size={16} />
                                  )}
                                </div>

                                <Collapse isOpen={isNumerosAccordionOpen}>
                                  <CardBody className="p-2">
                                    <div className="table-responsive">
                                      <table className="table table-bordered rounded-3 overflow-hidden">
                                        <tbody>
                                          {formNumeroTelephones.map(
                                            (rowData) => (
                                              <tr key={rowData.index}>
                                                {Object.entries(rowData).map(
                                                  ([key, value]) =>
                                                    key !== "id" &&
                                                    key !== "index" ? (
                                                      <td key={key}>
                                                        {key ===
                                                        "types_telephone_id" ? (
                                                          <select
                                                            value={value}
                                                            name="types_telephone_id"
                                                            className="form-control form-control-sm"
                                                            onChange={(e) =>
                                                              handleInputChangeTelephone(
                                                                rowData.index,
                                                                e.target.name,
                                                                e.target.value
                                                              )
                                                            }
                                                          >
                                                            {renderTypesTelephoneOptions()}
                                                          </select>
                                                        ) : key === "numero" ? (
                                                          <input
                                                            className="form-control form-control-sm"
                                                            value={value}
                                                            name="numero"
                                                            onChange={(e) =>
                                                              handleInputChangeTelephone(
                                                                rowData.index,
                                                                e.target.name,
                                                                e.target.value
                                                              )
                                                            }
                                                          />
                                                        ) : (
                                                          <span>{value}</span>
                                                        )}
                                                      </td>
                                                    ) : (
                                                      <td
                                                        className="d-none"
                                                        key={key}
                                                      >
                                                        <input
                                                          type="hidden"
                                                          size="10"
                                                          value={value}
                                                          readOnly
                                                        />
                                                      </td>
                                                    )
                                                )}
                                                <td
                                                  style={{
                                                    width: "1%",
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  <i
                                                    className="bx bx-trash"
                                                    style={{
                                                      fontSize: "20px",
                                                      paddingTop: "5px",
                                                      textAlign: "center",
                                                      verticalAlign: "middle",
                                                      cursor: "pointer",
                                                    }}
                                                    onClick={() =>
                                                      onDeleteFormNumeroTelephone(
                                                        rowData.index
                                                      )
                                                    }
                                                  ></i>
                                                </td>
                                              </tr>
                                            )
                                          )}
                                          <tr>
                                            <td colSpan="9">
                                              <button
                                                type="button"
                                                style={tableaustyles}
                                                className="btn btn-info mt-3 mt-lg-0"
                                                onClick={
                                                  onAddFormNumeroTelephone
                                                }
                                              >
                                                Ajouter
                                              </button>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </CardBody>
                                </Collapse>
                              </Card>
                            </Col>
                          </Row>
                        </>
                      ) : // Si le type est égal à PM (Personne morale)
                      !loading &&
                        investisseursData?.detail_investisseur?.identification
                          .Type == "PM" ? (
                        <>
                          <Row>
                            <Col sm="6">
                              <Card
                                className="shadow-sm border-0 overflow-hidden"
                                style={{ borderRadius: "12px" }}
                              >
                                {/* En-tête cliquable */}
                                <div
                                  className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                  style={{
                                    background: "#555B21",
                                    letterSpacing: "0.5px",
                                    cursor: "pointer",
                                    userSelect: "none",
                                  }}
                                  onClick={toggleIdentificationMoralAccordion}
                                >
                                  <div className="d-flex align-items-center">
                                    <span style={{ fontSize: "0.82rem" }}>
                                      Identification
                                    </span>
                                  </div>
                                  {isIdentificationMoralAccordionOpen ? (
                                    <FiChevronUp size={16} />
                                  ) : (
                                    <FiChevronDown size={16} />
                                  )}
                                </div>

                                {/* Contenu repliable */}
                                <Collapse
                                  isOpen={isIdentificationMoralAccordionOpen}
                                >
                                  <CardBody className="p-0">
                                    <div
                                      className="fields-container"
                                      style={{ paddingBottom: "8px" }}
                                    >
                                      {Object.entries(
                                        investisseursData
                                          ?.detail_nom_investisseur
                                          ?.identification || {}
                                      ).map(([key, value], index) => {
                                        const isRequired =
                                          key === "Dénomination sociale";

                                        return (
                                          <div
                                            key={index}
                                            className="field-item px-2 py-1"
                                            style={{
                                              backgroundColor: "white",
                                              transition: "all 0.15s ease",
                                              borderLeft: isRequired
                                                ? "3px solid #dc3545"
                                                : "3px solid transparent",
                                              position: "relative",
                                            }}
                                            onMouseEnter={(e) => {
                                              if (isRequired) {
                                                e.currentTarget.style.backgroundColor =
                                                  "#ffe6e6";
                                                e.currentTarget.style.borderLeftColor =
                                                  "#dc3545";
                                              } else {
                                                e.currentTarget.style.backgroundColor =
                                                  "#e3f2fd";
                                                e.currentTarget.style.borderLeftColor =
                                                  "#007bff";
                                              }
                                            }}
                                            onMouseLeave={(e) => {
                                              e.currentTarget.style.backgroundColor =
                                                "white";
                                              if (isRequired) {
                                                e.currentTarget.style.borderLeftColor =
                                                  "#dc3545";
                                              } else {
                                                e.currentTarget.style.borderLeftColor =
                                                  "transparent";
                                              }
                                            }}
                                          >
                                            {/* Ligne de séparation subtile */}
                                            {index > 0 && (
                                              <div
                                                className="field-separator"
                                                style={{
                                                  position: "absolute",
                                                  top: "0",
                                                  left: "0",
                                                  right: "66%",
                                                  height: "1px",
                                                  background:
                                                    "linear-gradient(90deg, transparent 0%, #e9ecef 20%, #e9ecef 80%, transparent 100%)",
                                                }}
                                              />
                                            )}

                                            <Row className="align-items-center g-1">
                                              {/* Label */}
                                              <Col
                                                xs={12}
                                                md={4}
                                                className="field-label"
                                              >
                                                <div className="d-flex align-items-center small text-muted">
                                                  <span
                                                    className="fw-medium"
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      letterSpacing: "0.2px",
                                                    }}
                                                  >
                                                    {key}
                                                    {key ===
                                                      "Dénomination sociale" &&
                                                      "*"}
                                                  </span>
                                                  <span className="ms-1 text-primary">
                                                    :
                                                  </span>
                                                </div>
                                              </Col>

                                              {/* Valeur / Input */}
                                              <Col
                                                xs={12}
                                                md={8}
                                                className="field-input"
                                              >
                                                {key ===
                                                "Dénomination sociale" ? (
                                                  <div className="input-wrapper position-relative">
                                                    <input
                                                      className={`form-control form-control-sm shadow-sm border-0 ${
                                                        denomSocial === ""
                                                          ? "is-invalid"
                                                          : ""
                                                      }`}
                                                      value={denomSocial}
                                                      onChange={(e) =>
                                                        setDenomSocial(
                                                          e.target.value
                                                        )
                                                      }
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        backgroundColor:
                                                          "#f8f9fa",
                                                        borderRadius: "6px",
                                                        padding:
                                                          "0.375rem 2rem 0.375rem 0.5rem",
                                                        height: "32px",
                                                        transition:
                                                          "all 0.2s ease",
                                                      }}
                                                      onFocus={(e) => {
                                                        e.currentTarget.style.backgroundColor =
                                                          "#ffffff";
                                                        e.currentTarget.style.boxShadow =
                                                          "0 0 0 0.2rem rgba(220, 53, 69, 0.15)";
                                                      }}
                                                      onBlur={(e) => {
                                                        e.currentTarget.style.backgroundColor =
                                                          "#f8f9fa";
                                                        e.currentTarget.style.boxShadow =
                                                          "none";
                                                      }}
                                                    />
                                                    <FiEdit3
                                                      size={12}
                                                      className="position-absolute text-muted"
                                                      style={{
                                                        right: "8px",
                                                        top: "50%",
                                                        transform:
                                                          "translateY(-50%)",
                                                        pointerEvents: "none",
                                                        opacity: 0.9,
                                                      }}
                                                    />
                                                    {denomSocial === "" && (
                                                      <div className="invalid-feedback d-block mt-1 small">
                                                        Dénomination sociale ne
                                                        peut pas être vide
                                                      </div>
                                                    )}
                                                  </div>
                                                ) : key === "N° RCS" ? (
                                                  <div className="input-wrapper position-relative">
                                                    <input
                                                      className="form-control form-control-sm shadow-sm border-0"
                                                      value={numeroRcs}
                                                      onChange={(e) =>
                                                        setNumeroRcs(
                                                          e.target.value
                                                        )
                                                      }
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        backgroundColor:
                                                          "#f8f9fa",
                                                        borderRadius: "6px",
                                                        padding:
                                                          "0.375rem 2rem 0.375rem 0.5rem",
                                                        height: "32px",
                                                        transition:
                                                          "all 0.2s ease",
                                                      }}
                                                      onFocus={(e) => {
                                                        e.currentTarget.style.backgroundColor =
                                                          "#ffffff";
                                                        e.currentTarget.style.boxShadow =
                                                          "0 0 0 0.2rem rgba(0, 123, 255, 0.15)";
                                                      }}
                                                      onBlur={(e) => {
                                                        e.currentTarget.style.backgroundColor =
                                                          "#f8f9fa";
                                                        e.currentTarget.style.boxShadow =
                                                          "none";
                                                      }}
                                                    />
                                                    <FiEdit3
                                                      size={12}
                                                      className="position-absolute text-muted"
                                                      style={{
                                                        right: "8px",
                                                        top: "50%",
                                                        transform:
                                                          "translateY(-50%)",
                                                        pointerEvents: "none",
                                                        opacity: 0.9,
                                                      }}
                                                    />
                                                  </div>
                                                ) : (
                                                  <div className="input-wrapper position-relative">
                                                    <span
                                                      style={{
                                                        display: "block",
                                                        padding:
                                                          "0.25rem 0.5rem",
                                                        fontSize: "0.8rem",
                                                        color: "#495057",
                                                        backgroundColor:
                                                          "#f8f9fa",
                                                        borderRadius: "6px",
                                                        minHeight: "32px",
                                                        lineHeight: "1.5",
                                                      }}
                                                    >
                                                      {renderValue(value)}
                                                    </span>
                                                  </div>
                                                )}
                                              </Col>
                                            </Row>
                                          </div>
                                        );
                                      })}
                                    </div>
                                  </CardBody>
                                </Collapse>
                              </Card>
                            </Col>

                            <Col sm="6">
                              <Card
                                className="shadow-sm border-0 overflow-hidden"
                                style={{ borderRadius: "12px" }}
                              >
                                {/* En-tête cliquable */}
                                <div
                                  className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                  style={{
                                    background: "#555B21",
                                    letterSpacing: "0.5px",
                                    cursor: "pointer",
                                    userSelect: "none",
                                  }}
                                  onClick={toggleContactAccordion}
                                >
                                  <div className="d-flex align-items-center">
                                    <span style={{ fontSize: "0.82rem" }}>
                                      Contact
                                    </span>
                                  </div>
                                  {isContactAccordionOpen ? (
                                    <FiChevronUp size={16} />
                                  ) : (
                                    <FiChevronDown size={16} />
                                  )}
                                </div>

                                {/* Contenu repliable */}
                                <Collapse isOpen={isContactAccordionOpen}>
                                  <CardBody className="p-0">
                                    <div
                                      className="fields-container"
                                      style={{ paddingBottom: "8px" }}
                                    >
                                      {Object.entries(
                                        investisseursData
                                          ?.detail_nom_investisseur?.contact ||
                                          {}
                                      ).map(([key, value], index) => (
                                        <div
                                          key={index}
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid transparent",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor =
                                              "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "transparent";
                                          }}
                                        >
                                          {index > 0 && (
                                            <div
                                              className="field-separator"
                                              style={{
                                                position: "absolute",
                                                top: "0",
                                                left: "0",
                                                right: "66%",
                                                height: "1px",
                                                background:
                                                  "linear-gradient(90deg, transparent 0%, #e9ecef 20%, #e9ecef 80%, transparent 100%)",
                                              }}
                                            />
                                          )}

                                          <Row className="align-items-center g-1">
                                            {/* Label */}
                                            <Col
                                              xs={12}
                                              md={4}
                                              className="field-label"
                                            >
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  {key}
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>

                                            {/* Valeur / input */}
                                            <Col
                                              xs={12}
                                              md={8}
                                              className="field-input"
                                            >
                                              {key === "Téléphone" ? (
                                                <div className="input-wrapper position-relative">
                                                  <input
                                                    className="form-control form-control-sm shadow-sm border-0"
                                                    value={telephone}
                                                    onChange={(e) =>
                                                      setTelephone(
                                                        e.target.value
                                                      )
                                                    }
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      backgroundColor:
                                                        "#f8f9fa",
                                                      borderRadius: "6px",
                                                      padding:
                                                        "0.375rem 2rem 0.375rem 0.5rem",
                                                      height: "32px",
                                                      transition:
                                                        "all 0.2s ease",
                                                    }}
                                                    onFocus={(e) => {
                                                      e.currentTarget.style.backgroundColor =
                                                        "#ffffff";
                                                      e.currentTarget.style.boxShadow =
                                                        "0 0 0 0.2rem rgba(0, 123, 255, 0.15)";
                                                    }}
                                                    onBlur={(e) => {
                                                      e.currentTarget.style.backgroundColor =
                                                        "#f8f9fa";
                                                      e.currentTarget.style.boxShadow =
                                                        "none";
                                                    }}
                                                  />
                                                  <FiEdit3
                                                    size={12}
                                                    className="position-absolute text-muted"
                                                    style={{
                                                      right: "8px",
                                                      top: "50%",
                                                      transform:
                                                        "translateY(-50%)",
                                                      pointerEvents: "none",
                                                      opacity: 0.9,
                                                    }}
                                                  />
                                                </div>
                                              ) : key === "Fax" ? (
                                                <div className="input-wrapper position-relative">
                                                  <input
                                                    className="form-control form-control-sm shadow-sm border-0"
                                                    value={fax}
                                                    onChange={(e) =>
                                                      setFax(e.target.value)
                                                    }
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      backgroundColor:
                                                        "#f8f9fa",
                                                      borderRadius: "6px",
                                                      padding:
                                                        "0.375rem 2rem 0.375rem 0.5rem",
                                                      height: "32px",
                                                      transition:
                                                        "all 0.2s ease",
                                                    }}
                                                    onFocus={(e) => {
                                                      e.currentTarget.style.backgroundColor =
                                                        "#ffffff";
                                                      e.currentTarget.style.boxShadow =
                                                        "0 0 0 0.2rem rgba(0, 123, 255, 0.15)";
                                                    }}
                                                    onBlur={(e) => {
                                                      e.currentTarget.style.backgroundColor =
                                                        "#f8f9fa";
                                                      e.currentTarget.style.boxShadow =
                                                        "none";
                                                    }}
                                                  />
                                                  <FiEdit3
                                                    size={12}
                                                    className="position-absolute text-muted"
                                                    style={{
                                                      right: "8px",
                                                      top: "50%",
                                                      transform:
                                                        "translateY(-50%)",
                                                      pointerEvents: "none",
                                                      opacity: 0.9,
                                                    }}
                                                  />
                                                </div>
                                              ) : key === "Email" ? (
                                                <div className="input-wrapper position-relative">
                                                  <input
                                                    className="form-control form-control-sm shadow-sm border-0"
                                                    type="email"
                                                    value={emailPm}
                                                    onChange={(e) =>
                                                      setEmailPm(e.target.value)
                                                    }
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      backgroundColor:
                                                        "#f8f9fa",
                                                      borderRadius: "6px",
                                                      padding:
                                                        "0.375rem 2rem 0.375rem 0.5rem",
                                                      height: "32px",
                                                      transition:
                                                        "all 0.2s ease",
                                                    }}
                                                    onFocus={(e) => {
                                                      e.currentTarget.style.backgroundColor =
                                                        "#ffffff";
                                                      e.currentTarget.style.boxShadow =
                                                        "0 0 0 0.2rem rgba(0, 123, 255, 0.15)";
                                                    }}
                                                    onBlur={(e) => {
                                                      e.currentTarget.style.backgroundColor =
                                                        "#f8f9fa";
                                                      e.currentTarget.style.boxShadow =
                                                        "none";
                                                    }}
                                                  />
                                                  <FiEdit3
                                                    size={12}
                                                    className="position-absolute text-muted"
                                                    style={{
                                                      right: "8px",
                                                      top: "50%",
                                                      transform:
                                                        "translateY(-50%)",
                                                      pointerEvents: "none",
                                                      opacity: 0.9,
                                                    }}
                                                  />
                                                </div>
                                              ) : (
                                                <div className="input-wrapper position-relative">
                                                  <span
                                                    style={{
                                                      display: "block",
                                                      padding: "0.25rem 0.5rem",
                                                      fontSize: "0.8rem",
                                                      color: "#495057",
                                                      backgroundColor:
                                                        "#f8f9fa",
                                                      borderRadius: "6px",
                                                      minHeight: "32px",
                                                      lineHeight: "1.5",
                                                    }}
                                                  >
                                                    {renderValue(value)}
                                                  </span>
                                                </div>
                                              )}
                                            </Col>
                                          </Row>
                                        </div>
                                      ))}
                                    </div>
                                  </CardBody>
                                </Collapse>
                              </Card>
                            </Col>
                          </Row>
                          <Row>
                            <Col sm="6">
                              <Card
                                className="shadow-sm border-0 overflow-hidden"
                                style={{ borderRadius: "12px" }}
                              >
                                {/* En-tête cliquable */}
                                <div
                                  className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                  style={{
                                    background: "#555B21",
                                    letterSpacing: "0.5px",
                                    cursor: "pointer",
                                    userSelect: "none",
                                  }}
                                  onClick={toggleCaracteristiquesAccordion}
                                >
                                  <div className="d-flex align-items-center">
                                    <span style={{ fontSize: "0.82rem" }}>
                                      Caractéristiques
                                    </span>
                                  </div>
                                  {isCaracteristiquesAccordionOpen ? (
                                    <FiChevronUp size={16} />
                                  ) : (
                                    <FiChevronDown size={16} />
                                  )}
                                </div>

                                {/* Contenu repliable */}
                                <Collapse
                                  isOpen={isCaracteristiquesAccordionOpen}
                                >
                                  <CardBody className="p-0">
                                    <div
                                      className="fields-container"
                                      style={{ paddingBottom: "8px" }}
                                    >
                                      {Object.entries(
                                        investisseursData
                                          ?.detail_nom_investisseur
                                          ?.caracteristiques || {}
                                      ).map(([key, value], index) => (
                                        <div
                                          key={index}
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid transparent",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor =
                                              "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "transparent";
                                          }}
                                        >
                                          {/* Ligne de séparation subtile */}
                                          {index > 0 && (
                                            <div
                                              className="field-separator"
                                              style={{
                                                position: "absolute",
                                                top: "0",
                                                left: "0",
                                                right: "66%",
                                                height: "1px",
                                                background:
                                                  "linear-gradient(90deg, transparent 0%, #e9ecef 20%, #e9ecef 80%, transparent 100%)",
                                              }}
                                            />
                                          )}

                                          <Row className="align-items-center g-1">
                                            {/* Label */}
                                            <Col
                                              xs={12}
                                              md={4}
                                              className="field-label"
                                            >
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  {key}
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>

                                            {/* Valeur / Select */}
                                            <Col
                                              xs={12}
                                              md={8}
                                              className="field-input"
                                            >
                                              {key === "Forme juridique" ? (
                                                <div className="select-wrapper">
                                                  <Select
                                                    value={
                                                      selectedForme?.label ==
                                                      null
                                                        ? null
                                                        : selectedForme
                                                    }
                                                    onChange={handleFormeChange}
                                                    options={renderFormeOptions()}
                                                    isClearable={true}
                                                    classNamePrefix="select2-selection"
                                                    styles={styles(false)}
                                                    menuPortalTarget={
                                                      document.body
                                                    }
                                                    placeholder="Sélectionner une forme..."
                                                  />
                                                </div>
                                              ) : key === "Président (PM)" ? (
                                                <div className="select-wrapper">
                                                  <Select
                                                    value={
                                                      selectedPresidentPM?.label ==
                                                      null
                                                        ? null
                                                        : selectedPresidentPM
                                                    }
                                                    onChange={
                                                      handlePresidentChange
                                                    }
                                                    options={renderPresidentOptions()}
                                                    isClearable={true}
                                                    classNamePrefix="select2-selection"
                                                    styles={styles(false)}
                                                    menuPortalTarget={
                                                      document.body
                                                    }
                                                    placeholder="Sélectionner un président (PM)..."
                                                  />
                                                </div>
                                              ) : key ===
                                                "Directeur Général" ? (
                                                <div className="select-wrapper">
                                                  <Select
                                                    value={
                                                      selectedDir?.label == null
                                                        ? null
                                                        : selectedDir
                                                    }
                                                    onChange={
                                                      handleDirecteurChange
                                                    }
                                                    options={renderDirecteurOptions()}
                                                    isClearable={true}
                                                    classNamePrefix="select2-selection"
                                                    styles={styles(false)}
                                                    menuPortalTarget={
                                                      document.body
                                                    }
                                                    placeholder="Sélectionner un directeur général..."
                                                  />
                                                </div>
                                              ) : key === "Président (PP)" ? (
                                                <div className="select-wrapper">
                                                  <Select
                                                    value={
                                                      selectedPresidentPP?.label ==
                                                      null
                                                        ? null
                                                        : selectedPresidentPP
                                                    }
                                                    onChange={
                                                      handlePresidentPPChange
                                                    }
                                                    options={renderDirecteurOptions()}
                                                    isClearable={true}
                                                    classNamePrefix="select2-selection"
                                                    styles={styles(false)}
                                                    menuPortalTarget={
                                                      document.body
                                                    }
                                                    placeholder="Sélectionner un président (PP)..."
                                                  />
                                                </div>
                                              ) : (
                                                <div className="input-wrapper position-relative">
                                                  <span
                                                    style={{
                                                      display: "block",
                                                      padding: "0.25rem 0.5rem",
                                                      fontSize: "0.8rem",
                                                      color: "#495057",
                                                      backgroundColor:
                                                        "#f8f9fa",
                                                      borderRadius: "6px",
                                                      minHeight: "32px",
                                                      lineHeight: "1.5",
                                                    }}
                                                  >
                                                    {renderValue(value)}
                                                  </span>
                                                </div>
                                              )}
                                            </Col>
                                          </Row>
                                        </div>
                                      ))}
                                    </div>
                                  </CardBody>
                                </Collapse>
                              </Card>
                            </Col>
                          </Row>
                          <Row>
                            <Col sm="12">
                              <Card
                                className="shadow-sm border-0 overflow-hidden mb-4"
                                style={{ borderRadius: "12px" }}
                              >
                                {/* En‑tête cliquable */}
                                <div
                                  className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                  style={{
                                    background: "#555B21",
                                    letterSpacing: "0.5px",
                                    cursor: "pointer",
                                    userSelect: "none",
                                  }}
                                  onClick={toggleAdressesAccordion}
                                >
                                  <div className="d-flex align-items-center">
                                    <span style={{ fontSize: "0.82rem" }}>
                                      Adresses
                                    </span>
                                  </div>
                                  {isAdressesAccordionOpen ? (
                                    <FiChevronUp size={16} />
                                  ) : (
                                    <FiChevronDown size={16} />
                                  )}
                                </div>

                                <Collapse isOpen={isAdressesAccordionOpen}>
                                  <CardBody className="p-2">
                                    <div className="table-responsive">
                                      <table className="table table-bordered rounded-3 overflow-hidden">
                                        <thead>
                                          <tr>
                                            {investisseursData?.detail_nom_investisseur?.adresses?.Adresses.header.map(
                                              (columnName, index) => (
                                                <th
                                                  className="text-nowrap"
                                                  style={tableaustyles}
                                                  key={index}
                                                >
                                                  {columnName}
                                                </th>
                                              )
                                            )}
                                            <th
                                              className="text-nowrap"
                                              style={tableaustyles}
                                              key="Del"
                                            ></th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {formAdressePostals.map(
                                            (rowData, index) => (
                                              <tr key={index}>
                                                {Object.entries(rowData).map(
                                                  ([key, value]) =>
                                                    key !== "id" &&
                                                    key !== "index" ? (
                                                      <td key={key}>
                                                        {key === "siege" ? (
                                                          <div>
                                                            <select
                                                              className="form-control form-control-sm"
                                                              style={{
                                                                minWidth:
                                                                  "70px",
                                                              }}
                                                              value={value}
                                                              name="siege"
                                                              onChange={(e) =>
                                                                handleInputChange(
                                                                  rowData.index,
                                                                  e.target.name,
                                                                  e.target.value
                                                                )
                                                              }
                                                            >
                                                              {renderYesNoOptions()}
                                                            </select>
                                                            {value === "" && (
                                                              <div
                                                                className="mt-1"
                                                                style={{
                                                                  color: "red",
                                                                  whiteSpace:
                                                                    "nowrap",
                                                                  fontSize: 12,
                                                                }}
                                                              >
                                                                Siège ne peut
                                                                pas être vide
                                                              </div>
                                                            )}
                                                          </div>
                                                        ) : key === "adresse" ||
                                                          key ===
                                                            "complement" ||
                                                          key ===
                                                            "code_postal" ||
                                                          key === "ville" ||
                                                          key === "pay_id" ||
                                                          key === "tel" ? (
                                                          <input
                                                            className="form-control form-control-sm"
                                                            style={{
                                                              minWidth:
                                                                key ===
                                                                "adresse"
                                                                  ? "150px"
                                                                  : "80px",
                                                            }}
                                                            value={value}
                                                            name={key}
                                                            onChange={(e) =>
                                                              handleInputChange(
                                                                rowData.index,
                                                                e.target.name,
                                                                e.target.value
                                                              )
                                                            }
                                                          />
                                                        ) : (
                                                          ""
                                                        )}
                                                      </td>
                                                    ) : (
                                                      <td
                                                        key={key}
                                                        className="d-none"
                                                      >
                                                        <input
                                                          type="hidden"
                                                          size="10"
                                                          value={value}
                                                          readOnly
                                                        />
                                                      </td>
                                                    )
                                                )}
                                                <td
                                                  style={{
                                                    width: "1%",
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  <i
                                                    className="bx bx-trash"
                                                    style={{
                                                      fontSize: "20px",
                                                      paddingTop: "5px",
                                                      cursor: "pointer",
                                                    }}
                                                    onClick={() =>
                                                      onDeleteFormAdressePostalPM(
                                                        rowData.index
                                                      )
                                                    }
                                                  ></i>
                                                </td>
                                              </tr>
                                            )
                                          )}
                                          <tr>
                                            <td colSpan="9">
                                              <button
                                                type="button"
                                                style={tableaustyles}
                                                className="btn btn-info mt-3 mt-lg-0"
                                                onClick={
                                                  onAddFormAdressePostalPM
                                                }
                                              >
                                                Ajouter
                                              </button>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </CardBody>
                                </Collapse>
                              </Card>
                            </Col>
                          </Row>
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} setWait={wait} />
                      )}
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <ToastContainer />
    </React.Fragment>
  );
}

export default InvestorDetail;
